(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
var CIC = require('../../sdk/CrossIframeCommunication');
var config = require('../../sdk/config.js');
var bootstrapping = require('../../sdk/bootstrapping.js');

var baseUrl = config.appDomain + '/sdk/auth/accessrules/?id={webcastId}&cic=i18n,info';

module.exports = AccessRulesClient;

function AccessRulesClient(options) {
    var _this = this;

    this.options = options;
    this.webcastId = options.webcastId;
    this.i18n = options.i18n;
    this.info = options.info;

    var cic = new CIC(this.webcastId + '/auth/accessrules');

    this.auth = options.auth;
    this.setTokens = options.auth.accessRules.setTokens;
    this.getTokens = options.auth.accessRules.getTokens;
    this.hasForms = options.auth.accessRules.hasForms;
    this.on = cic.on;
    this.openInIframe = openInIframe;
    this.openInNewWindow = openInNewWindow;

    Object.defineProperty(this, 'tokens', { get: function () { return options.auth.accessRules.tokens; } });

    cic.one('tokens', function (e) {
        options.auth.accessRules.setTokens(e.tokens);
    });

    function openInIframe(options) {
        options = options || {};
        var iframe = options.element || document.createElement('iframe');
        iframe.src = getUrl(options);
        if (options.transparent) iframe.allowTransparency = true;

        iframe.style.border = 'none';
        iframe.style.width = '100%';
        iframe.style.height = '100%';

        setTimeout(function () {
            init(iframe.contentWindow);
        }, 0);

        return iframe;
    }

    function openInNewWindow(options) {
        options = options || {};
        var newWindow = window.open(getUrl(options), '_blank');
        init(newWindow);
        cic.one('tokens', function (e) {
            if (newWindow) newWindow.close();
        });
    }

    function init(window) {
        cic.one('ready', function (e) {
            cic.postMessage(window, 'i18n', { i18n: _this.i18n });
            cic.postMessage(window, 'info', { info: _this.info });
        });
    }

    function getUrl(options) {
        var url = baseUrl.replace('{webcastId}', _this.webcastId);
        var identificationToken = options.identificationToken || _this.auth.identity.identificationToken;

        if (options.transparent) url += '&transparent';
        if (_this.options.autosubmit) url += '&autosubmit';
        if (identificationToken) url += '&identificationToken=' + identificationToken;
        if (bootstrapping.query.customBtnColor) url += '&customBtnColor=' + bootstrapping.query.customBtnColor.default + ',' + bootstrapping.query.customBtnColor.disabled;

        return url;
    }    
}


},{"../../sdk/CrossIframeCommunication":8,"../../sdk/bootstrapping.js":19,"../../sdk/config.js":21}],2:[function(require,module,exports){
var CIC = require('../../sdk/CrossIframeCommunication');
var config = require('../../sdk/config.js');
var ProviderFactory = require('../../sdk/auth/provider/Factory.js');

var baseUrl = config.appDomain + '/sdk/auth/identity/?id={webcastId}&cic=info,i18n';

module.exports = IdentityClient;

function IdentityClient(options) {
    var _this = this;
    
    this.window = null;
    this.webcastId = options.webcastId;
    this.i18n = options.i18n;
    this.info = options.info;

    var cic = new CIC(this.webcastId + '/auth/identity');

    this.on = on;
    this.openInIframe = openInIframe;
    this.openInNewWindow = openInNewWindow;
    this.getIdentificationToken = options.auth.identity.getIdentificationToken;
    this.setIdentificationToken = options.auth.identity.setIdentificationToken;
    this.click = click;

    Object.defineProperty(this, 'identificationToken', { get: function () { return options.auth.identity.identificationToken } });

    cic.one('identificationToken', function (e) {
        //alert('received identificationToken from identity app, player should now load: ' + e.identificationToken);
        _this.setIdentificationToken(e.identificationToken);
    });


    function openInIframe(options) {
        options = options || {};
        var iframe = options.element || document.createElement('iframe');
        iframe.src = getUrl(options);
        if (options.transparent) iframe.allowTransparency = true;

        iframe.style.border = 'none';
        iframe.style.width = '100%';
        iframe.style.height = '100%';

        setTimeout(function () {
            init(iframe.contentWindow);
            _this.window = iframe.contentWindow;
        }, 0);

        cic.one('identificationToken', function (e) {
            iframe.parentNode.removeChild(iframe);
        });

        return iframe;
    }

    function click() {
        if (options.info.identityProviders.length == 1) {
            console.log(options.info.identityProviders[0]);
            //alert('requesting identity directly');
            new ProviderFactory({ info: options.info }).createProvider(options.info.identityProviders[0]).getIdentificationToken().then(function (identificationToken) {
                //alert('received identificationToken directly, player should now load: ' + identificationToken);
                _this.setIdentificationToken(identificationToken);
            });
        }
    }
    
    function on(event, callback) {
        options.auth.identity.on(event, callback);
        cic.on(event, callback);
    }

    function init(window) {
        cic.one('ready', function (e) {
            cic.postMessage(window, 'i18n', { i18n: _this.i18n });
            cic.postMessage(window, 'info', { info: _this.info });
        });
    }

    function openInNewWindow(options) {
        options = options || {};
        var newWindow = window.open(getUrl(options), '_blank');
        _this.window = newWindow;
        init(newWindow);
        cic.one('identificationToken', function (e) {
            if (_this.window) _this.window.close();
        });
    }

    function getUrl(options) {
        var url = baseUrl.replace('{webcastId}', _this.webcastId);
        var identificationToken = _this.identificationToken;

        if (options.transparent) url += '&transparent=true';
        if (identificationToken) url += '&identificationToken=' + identificationToken;

        return url;
    }


}


},{"../../sdk/CrossIframeCommunication":8,"../../sdk/auth/provider/Factory.js":16,"../../sdk/config.js":21}],3:[function(require,module,exports){
var Auth = require('../../sdk/Auth');
var IdentityClient = require('./IdentityClient.js');
var AccessRulesClient = require('./AccessRulesClient.js');

window.cwc = window.cwc || {};
window.cwc.sdk = window.cwc.sdk || {};
window.cwc.sdk.auth = window.cwc.sdk.auth|| {};

window.cwc.sdk.auth.client = {
    createAuth: function (options) {
        return new AuthClient(options);
    },
}

module.exports = AuthClient;

function AuthClient(options) {

    if (!options.info) throw new Error('options.info is undefined');
    if (!options.i18n) throw new Error('options.i18n is undefined');

    options.customerCode = options.info.customerCode;
    options.webcastId = options.info.id;

    var _this = this;

    this.auth = options.auth = new Auth(options);
    var identity = this.auth.identity;
    var accessRules = this.auth.accessRules;

    this.customerCode = options.customerCode;
    this.webcastId = options.webcastId;
    this.identificationToken = options.identificationToken;
    this.info = options.info;
    this.i18n = options.i18n;
    this.on = on;

    this.identity = new IdentityClient(options);
    this.accessRules = new AccessRulesClient(options);

    function on(event, callback) {
        this.identity.on(event, callback);
        this.accessRules.on(event, callback);
    }
}
},{"../../sdk/Auth":7,"./AccessRulesClient.js":1,"./IdentityClient.js":2}],4:[function(require,module,exports){
var bootstrapping = require('../../sdk/bootstrapping.js');
var Api = require('../../sdk/Api.js');

var CIC = require('../../sdk/CrossIframeCommunication.js');
var dom = require('../../sdk/dom.js');
var http = require('../../sdk/http.js');
var config = require('../../sdk/config.js')
var localStorage = require('../../sdk/localStorage.js')
var Auth = require('../../apps/auth/client.js');

var LegacyPulseForm = require('../shared/controls/LegacyPulseForm.js');
var Poster = require('../../sdk/Poster.js');
var GoogleAnalytics = require('../../sdk/player/GoogleAnalytics.js');
var log = require('../../sdk/log.js');
log.scope = { app: 'sdk.form', webcastId: bootstrapping.query.id, formId: bootstrapping.query.formId };



var params = bootstrapping.query;
var cic = new CIC(params.id + '.' + params.formId);
var api = new Api({
    cic: cic,
});

bootstrapping.registerFontSizeListener();

//api.googleAnalytics = new GoogleAnalytics(api);
//api.googleAnalytics.sendVirtualPageView('test');

dom.hide(document.getElementById('done'), true);

api.getInfo().then(function (info) {
    log.scope.webcastId = info.webcastId;
    log.scope.customerCode = info.customerCode;

    var googleAnalytics = new GoogleAnalytics({
        on: function () { },
        info: info,
    });

    new Poster(info.posters).writeToDom();

    api.getI18N().then(function (i18n) {

        var auth = new Auth({
            customerCode: info.customerCode,
            webcastId: info.id,
            identificationToken: params.identificationToken || localStorage.get(info.customerCode),
            info: info,
            i18n: i18n,
        });

        auth.identity.on('provider:request', function (e) {
            document.getElementById('auth').appendChild(auth.identity.openInIframe({ transparent: true }));
        });

        auth.identity.getIdentificationToken().then(function () {
            document.getElementById('auth').appendChild(auth.accessRules.openInIframe({ transparent: true }));
        });

        var authHttp = http.auth(auth);


        document.getElementById('done.label').textContent = i18n['label.survey.done'];

        var resourceUri = '/players/' + params.id + '/resources/' + params.formId;

        if (params.formId == 'survey') resourceUri = info.survey.surveyResource;

        if (false) {
            resourceUri = config.domain + resourceUri;
        }

        auth.accessRules.getTokens().then(function (tokens) {

            authHttp.get(resourceUri).json().then(function (form) {
                dom.fadeIn(document.getElementById('formcontainer'));
                var formType = form.formType || form.type || form.title.toLowerCase();
                document.title = formType;
                document.getElementById('done.label').textContent = i18n['label.' + formType + '.done'] || 'label.' + formType + '.done';

                if (localStorage.get(info.id + '/' + form.id)) {
                    dom.fadeIn(document.getElementById('done'));
                    cic.postMessage(window.opener, 'form.submit');
                } else {
                    var control = new LegacyPulseForm({
                        form: form,
                        info: info,
                        i18n: i18n,
                        auth: auth,
                        http: authHttp,
                        cancelable: false,
                        fullscreen: true,
                        googleAnalytics: googleAnalytics,
                        postSubmitMessage: i18n['label.' + formType + '.thanks'],
                        events: {
                            onExamCompleted: function () {
                                cic.postMessage(window.opener, 'form.submit');
                            },
                            onSubmit: function () {
                                localStorage.set(info.id + '/' + form.id, true);
                                cic.postMessage(window.opener, 'form.submit');
                                window.close();
                            }
                        }
                    });
                    document.getElementById('form').appendChild(control.element);
                }
            });
        });
    });
});

},{"../../apps/auth/client.js":3,"../../sdk/Api.js":6,"../../sdk/CrossIframeCommunication.js":8,"../../sdk/Poster.js":11,"../../sdk/bootstrapping.js":19,"../../sdk/config.js":21,"../../sdk/dom.js":24,"../../sdk/http.js":26,"../../sdk/localStorage.js":28,"../../sdk/log.js":29,"../../sdk/player/GoogleAnalytics.js":31,"../shared/controls/LegacyPulseForm.js":5}],5:[function(require,module,exports){
var dom = require('../../../sdk/dom.js');
var bootstrapping = require('../../../sdk/bootstrapping.js');
var config = require('../../../sdk/config.js');
var http = require('../../../sdk/http.js');
var localStorage = require('../../../sdk/localStorage.js');

module.exports = LegacyPulseForm;

var questionTypes = {
    text: 1,
    textString: 'text',
    multi: 2,
    multiString: 'multipleAnswer',
    single: 3,
    singleString: 'singleAnswer',
    password: 4,
    passwordString: 'password',
    recaptchav2: 5,
    recaptchav2String: 'recaptchav2',
}

var call2ActionTypes = {
    none: 'none',
    url: 'url',
    survey: '#SurveyForm',
    attend: 'webcast',
}

var icons = {
    submit: 'fa fa-chevron-right fa-fw',
    unavailable: 'icon icon-spin icon-loading',
}

var expandedForms = ['poll', 'exam', 'pretest'];
var expandedStyle = ['exam', 'pretest'];

var labelClass = '';

var showRememberme = false;

function LegacyPulseForm(options) {
    options.events = options.events || {};
    options.events.onSubmit = options.events.onSubmit || function () { }
    options.events.onCancel = options.events.onCancel || function () { }
    options.events.onError = options.events.onError || function () { }
    options.labels = options.labels || {};

    if (false && options.form && options.form.submitUri && options.form.submitUri.indexOf('sdk-staging') == -1) {
        options.form.submitUri = config.domain + options.form.submitUri;
    }

    var _this = this;
    var clientWindow;

    this.answers = {};
    this.questions = {};
    this.options = {};
    this.form = options.form;
    this.retries = parseInt(localStorage.get(options.form.id + '.retries')) || 0;


    this.elements = {};

    this.element = dom.create({
        element: 'div',
        class: 'background-gradient',
    });

    if (expandedStyle.indexOf(options.form.formType || options.form.type) > -1) {
        this.element.classList.add('expandedform');
    }

    var errors = [];

    _this.elements.formFooter = createFooter();

    _this.elements.cancelBtn = dom.create({
        element: 'button',
        class: 'btn btn-close',
        textContent: options.i18n['label.close'],
        events: {
            click: cancel,
        }
    });

    _this.elements.formHeader = createHeader();
    _this.elements.formBody = createBody();

    _this.elements.form = dom.create({
        element: 'div',
        children: [
            _this.elements.formHeader,
            _this.elements.formBody,
            _this.elements.formFooter,
        ]
    });

    _this.elements.postSubmitMessage = createPostSubmitMessage();
    _this.elements.errorMessage = createErrorMessage();
    _this.elements.postExamReport = createPostExamReport();

    _this.elements.formContainer = dom.create({
        element: 'form',
        class: 'form',
        attributes: {
            'touch-action': 'pan-y'
        },
        children: [
            _this.elements.form,
            _this.elements.postSubmitMessage,
            _this.elements.errorMessage,
            _this.elements.postExamReport,
        ]
    });

    _this.elements.relativeContainer = dom.create({
        element: 'div',
        attributes: {
            style: 'position:relative;width:100%;height:100%;'
        },
        children: [
            dom.create({
                element: 'div',
                class: 'form-container',
                attributes: {
                    'touch-action': 'pan-y'
                },
                children: [_this.elements.formContainer],
            }),
        ]
    });

    if (options.cancelable) {
        _this.elements.relativeContainer.appendChild(_this.elements.cancelBtn);
    }

    _this.element.appendChild(_this.elements.relativeContainer);

    if (options.fullscreen) {
        _this.element.classList.add('view-form-fullscreen');
    } else {
        _this.element.classList.add('view-form');
    }

    if (options.info.exam && _this.retries > options.info.exam.retry.maxRetries && !localStorage.get(options.info.id + '/' + options.form.id)) {
        showPostExamReport(options.info.exam.failed, []);
    }

    if (options.done && options.postSubmitMessage) {
        showPostSubmit();
        window.setTimeout(function () {
            close();
        }, 2000);
    }

    function createHeader() {
        var span = dom.create({
            element: 'span',
            class: 'font-md font-bold',
            textContent: options.form.title,
        });

        var header = dom.create({
            element: 'div',
            class: 'form-header',
            children: [span],
        });

        if (options.form.formType == 'call2action' || options.form.formType == 'poll') {
            span.textContent = options.i18n['label.' + options.form.formType];
        }

        return header;
    }

    function createBody() {
        var body = dom.create({
            element: 'div',
            class: 'form-body',
            children: [
                dom.create({
                    element: 'p',
                    class: 'form-group font-sm',
                    textContent: options.form.description,
                })
            ]
        });

        for (var i = 0, len = options.form.questions.length; i < len; i++) {
            var question = options.form.questions[i];
            if (question.label != 'contact/middlename') {
                body.appendChild(createQuestion(question));
            }
        }

        return body;
    }

    function createPostSubmitMessage() {
        var body = dom.create({
            element: 'div',
            class: 'form-body',
            children: [
                dom.create({
                    element: 'p',
                    class: 'form-group',
                    attributes: {
                        style: 'text-align:center;'
                    },
                    textContent: options.postSubmitMessage,
                })
            ]
        });

        dom.hide(body, true);
        return body;
    }

    function createErrorMessage() {
        var label = dom.create({
            element: 'p',
            attributes: {
                style: 'text-align:center;'
            },
        });

        var btn = dom.create({
            element: 'button',
            class: 'btn btn-bright',
            textContent: options.i18n['label.continue'] || 'continue',
        });

        var body = dom.create({
            element: 'div',
            class: 'form-footer',
            children: [
                label,
                btn,
            ]
        });

        _this.elements.errorMessageLabel = label;
        _this.elements.errorMessageBtn = btn;

        dom.hide(body, true);
        return body;
    }

    function createPostExamReport() {

        var label = dom.create({
            element: 'div',
        });

        var btn = createPostExamCloseButton();

        var body = dom.create({
            element: 'div',
            class: 'form-body',
            children: [
                createPostExamCloseButton(),
                label,
                btn,
            ]
        });

        _this.elements.postExamReportLabel = label;
        _this.elements.postExamReportBtn = btn;

        dom.hide(body, true);
        return body;

    }

    function createPostExamCloseButton() {
        var survey = options.info.survey && getSurveyUrl();
        return dom.create({
            element: 'button',
            class: 'btn btn-bright',
            textContent: survey ? options.i18n['label.survey'] || 'survey' : options.i18n['label.close'] || 'close',
            events: {
                click: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    survey ? window.open(survey, '_self') : close();
                }
            }
        });
    }


    function createFooter() {

        var icon = dom.create({
            element: 'span',
            class: 'icon icon-spin icon-loading',
        });

        var label = dom.create({
            element: 'span',
        });

        var submitBtn = dom.create({
            element: 'button',
            attributes: {
                class: 'btn btn-bright',
                type: 'submit',
            },
            events: {
                click: submit,
            },
            children: [
                label,
                icon,
            ],
        });

        label.textContent = options.labels.submit || options.i18n['label.submit'] || 'Submit';

        dom.focusable(submitBtn);
        dom.hide(icon, true);

        _this.elements.submitIcon = icon;
        _this.elements.submitBtn = submitBtn;

        var footer = dom.create({
            element: 'div',
            class: 'form-footer',
            children: [submitBtn]
        });

        return footer;
    }

    function submit(e) {
        if (clientWindow) clientWindow.close();
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        //localStorage.setRememberMe(_this.rememberme.checked);

        if (errors.length == 0) {
            dom.fadeIn(_this.elements.submitIcon);
            _this.elements.submitBtn.disabled = true;

            var submitFunction = options.form.submit
                ? options.form.submit(_this.answers)
                : options.http.post(options.form.submitUri, _this.answers).form();

            submitFunction.then(function (result) {
                _this.submitted = true;
                if (options.googleAnalytics) options.googleAnalytics.sendVirtualPageView('form.' + (options.form.formType || options.form.type || options.form.title.toLowerCase()) + '.submit');

                if (options.form.formType == 'exam') {
                    if (result.passed == false && _this.retries < options.info.exam.retry.maxRetries) {
                        _this.retries++;
                        localStorage.set(options.form.id + '.retries', _this.retries);

                        _this.elements.errorMessageLabel.style.textAlign = '';
                        _this.elements.errorMessageLabel.textContent = options.info.exam.retry.label;
                        _this.elements.errorMessageBtn.onclick = function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            showForm();
                        }
                        showError();
                    } else {
                        localStorage.set(options.info.id + '/' + options.form.id, true);
                        localStorage.set(options.info.id + '/exam', true);
                        if (options.events.onExamCompleted) options.events.onExamCompleted();
                        showPostExamReport(result.passed ? options.info.exam.passed : options.info.exam.failed, rolfHeeftGeenZin(options.form, result));
                    }
                } else if (options.postSubmitMessage) {
                    showPostSubmit();
                    window.setTimeout(function () {
                        close();
                    }, 2000);
                } else {
                    document.activeElement.blur();
                    options.events.onSubmit();
                }
            }, function (e) {
                console.log('form.submit.error', e);

                if (options.info.exam) {

                } else {
                    _this.elements.errorMessageLabel.textContent = options.i18n[e.response.label] || e.response.message || options.i18n['error.unknown.description'];
                    _this.elements.errorMessageBtn.onclick = function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        showForm();
                    }
                    showError();
                }


                options.events.onError(e);
            });
        }
    }

    function close(e) {
        if (clientWindow) clientWindow.close();
        document.activeElement.blur();
        options.events.onSubmit();
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
    }

    function cancel(e) {
        if (clientWindow) clientWindow.close();
        document.activeElement.blur();
        if (_this.submitted) {
            options.events.onSubmit();
        } else {
            options.events.onCancel();
        }
        e.stopPropagation();
        e.preventDefault();
    }

    function createFormGroup(children) {
        return dom.create({
            element: 'div',
            class: 'form-group',
            children: children,
        });
    }

    function rolfHeeftGeenZin(form, result) {

        var questions = {};
        var options = {};
        var incorrectAnswers = {};
        var correctAnswers = {};

        var formattedResult = [];

        if (result.incorrectAnswers) {
            for (var i = 0, iLength = result.incorrectAnswers.length; i < iLength; i++) {
                incorrectAnswers[result.incorrectAnswers[i].id] = true;
                for (var j = 0, jLength = result.incorrectAnswers[i].correctAnswers.length; j < jLength; j++) {
                    correctAnswers[result.incorrectAnswers[i].correctAnswers[j]] = true;
                }
            }
        }

        for (var i = 0, iLength = form.questions.length; i < iLength; i++) {
            var question = form.questions[i];
            var formattedQuestion = {
                label: question.text,
                correct: !incorrectAnswers[question.id],
                options: [],
            }

            for (var j = 0, jLength = question.options.length; j < jLength; j++) {
                var option = question.options[j];
                var formattedOption = {
                    text: option.text,
                    correct: formattedQuestion.correct ? _this.answers[question.id].indexOf(option.id) > -1 : correctAnswers[option.id],
                    mine: option.id == _this.answers[question.id],
                }
                formattedQuestion.options.push(formattedOption);
            }


            formattedResult.push(formattedQuestion);
        }

        return formattedResult;
    }

    function createCall2Action(type, option, data, input, question) {

        return function (e) {
            if (!input.checked) return;
            switch (type) {
                case call2ActionTypes.url:
                    window.open(data.url, '_blank');
                    break;
                case call2ActionTypes.survey:

                    window.open(getSurveyUrl(), '_blank');
                    break;
            }
        }
    }

    function getSurveyUrl() {
        var url = '/sdk/form/?id=' + options.info.id + '&customerCode=' + options.info.customer.code + '&formId=survey';
        if (options.auth) url += '&identificationToken=' + options.auth.accessRules.tokens.legacyPulseToken;
        if (bootstrapping.query.customBtnColor) url += '&customBtnColor=' + bootstrapping.query.customBtnColor.default + ',' + bootstrapping.query.customBtnColor.disabled;

        return url;
    }

    function createQuestion(question) {
        question.text = question.text || '';

        if (options.form.formType != 'survey' && question.maxLength == 999) question.maxLength = 99;
        if (options.form.formType == 'poll') question.mandatory = true;

        var children = null;
        if (!Array.isArray(question.prefill)) {
            question.prefill = question.prefill ? question.prefill.split('~') : [];
        }

        question.gdpr = question.label && question.label.indexOf('gdpr') > -1;
        question.consent = question.label == 'consent';

        if (question.gdpr) {
            question.prefill = [];
            for (var i = 0, length = question.options.length; i < length; i++) {
                var option = question.options[i];
                option.hideGDPRCheckbox = option.reference.indexOf('hideCheckbox') > -1;
                if (option.hideGDPRCheckbox) question.prefill.push(option.id);
            }
        }

        if (options.form.formType == 'call2action' && question.options.length == 1) {
            dom.hide(_this.elements.submitBtn);
        }

        switch (question.type) {
            case questionTypes.text:
            case questionTypes.textString:
            case 'open':
                children = createTextInput(question);
                break;
            case questionTypes.multi:
            case questionTypes.multiString:
                children = createMultiCheckboxes(question);
                break;
            case questionTypes.single:
            case questionTypes.singleString:
                children = expandedForms.indexOf(options.form.formType || options.form.type) > -1 ? createRadioGroup(question) : createSingleSelect(question);
                break;
            case questionTypes.password:
            case questionTypes.passwordString:
                children = createPasswordInput(question);
                break;
            case questionTypes.recaptchav2:
            case questionTypes.recaptchav2String:
                children = createCaptcha(question);
                break;
            default:
                throw new Error('unsupported question type:' + question.type);
        }

        var formGroup = createFormGroup(children);
        formGroup.classList.add('question');

        question.formGroup = formGroup;
        onChange.call(question);
        _this.questions[question.id] = question;

        if (question.options) {
            for (var i = 0, length = question.options.length; i < length; i++) {
                _this.options[question.options[i].id] = question.options[i];
            }
        }

        return formGroup;
    }

    function createCaptcha(question) {
        question.input = { value: null }
        return [recaptcha.create(function (response) {
            question.input.value = response;
            onChange.call(question);
        })];
    }

    function createRadioGroup(question) {

        var children = [];
        var inputs = [];
        var elements = [];

        if (options.form.formType != 'call2action') {
            var label = dom.create({
                element: 'label',
                class: labelClass,
                textContent: question.text,
            });
            children.push(label);
        }

        for (var i = 0, len = question.options.length; i < len; i++) {
            var option = question.options[i];
            var group = createRadioGroupOption(question, option);
            children.push(group.element);
            elements.push(group.element);
            inputs.push(group.input);
        }

        question.input = inputs;
        question.elements = elements;
        return children;
    }

    function createRadioGroupOption(question, option) {
        var input = dom.create({
            element: 'input',
            attributes: {
                type: 'radio',
                name: question.id,
                value: option.id,
                id: option.id,
                'touch-action': 'pan-y',
            },
            events: {
                change: onChange.bind(question),
                click: function (e) { e.stopPropagation(); }
            }
        });

        if (question.prefill.indexOf(option.text) > -1) {
            input.checked = true;
        }

        if (!_this.firstInput) _this.firstInput = input;

        var el = createFormGroup([
            input,
            dom.create({
                element: 'span',
                class: 'icon',
                events: {
                    click: function () {
                        input.click();
                    }
                }
            }),
            dom.create({
                element: 'label',
                class: labelClass,
                textContent: option.text,
                attributes: {
                    'for': option.id,
                },
            }),
        ]);

        if (options.form.formType == 'poll') {
            el.classList.add('bordered');
            el.classList.add('checkbox');
            input.addEventListener('change', function (e) {

                for (var i = 0, length = question.input.length; i < length; i++) {
                    var input = question.input[i];
                    var el = question.elements[i];

                    if (input.id == option.id) {
                        el.classList.add('checked');
                    } else {
                        el.classList.remove('checked');
                    }
                }
            });
        }


        el.addEventListener('click', function (e) {
            e.stopPropagation();
            e.preventDefault();
            input.click();
        });

        return {
            element: el,
            input: input,
        }
    }

    function createSingleSelect(question) {

        var label = dom.create({
            element: 'label',
            attributes: {
                for: question.id,
            },
            textContent: question.text,
        });

        var select = dom.create({
            element: 'select',
            class: 'form-control',
            attributes: {
                id: question.id,
            },
            events: {
                change: onChange.bind(question)
            }
        });

        if (!_this.firstInput) _this.firstInput = select;

        select.appendChild(dom.create({
            element: 'option',
            attributes: {
                value: '',
            },
            textContent: options.form.formType == 'survey' ? '' : question.text,
        }));

        for (var i = 0, len = question.options.length; i < len; i++) {
            var option = question.options[i];

            select.appendChild(dom.create({
                element: 'option',
                attributes: {
                    value: option.id,
                },
                textContent: option.text,
            }))

            if (question.prefill.indexOf(option.text) > -1) select.value = option.id;
        }

        question.input = select;


        if (options.form.formType != 'survey') {
            return [select];
        }

        return [label, select];
    }

    function createPasswordInput(question) {
        var input = dom.create({
            element: 'input',
            attributes: {
                class: 'form-control',
                type: 'password',
                placeholder: question.text,
                'touch-action': 'pan-y',
            },
            events: {
                input: onChange.bind(question),
            }
        });
        if (!_this.firstInput) _this.firstInput = input;
        dom.focusable(input);
        question.input = input;
        question.re = new RegExp(question.validation);
        return [input];
    }

    function createTextInput(question) {

        var type = 'text';
        if (question.label == 'contact/email') {
            type = 'email';
            if (question.prefill.length == 0) {
                var email = localStorage.get('user.email');
                if (email) {
                    question.prefill = [email];
                }
            }
        }

        var label = dom.create({
            element: 'label',
            attributes: {
                for: question.id,
            },
            textContent: question.text,
        });

        var input = dom.create({
            element: question.maxLength > 900 ? 'textarea' : 'input',
            attributes: {
                class: 'form-control',
                type: type,
                'touch-action': 'pan-y',
                id: question.id,
            },
            events: {
                input: onChange.bind(question),
            }
        });

        dom.focusable(input);

        if (question.maxLength > 900) {
            input.setAttribute('rows', 4);
        }

        if (question.label == 'contact/email') {
            input.setAttribute('autocorrect', 'off');
            input.setAttribute('autocapitalize', 'none');
        }

        if (question.prefill.length > 0) {
            input.value = question.prefill[0] || '';
        }

        if (!_this.firstInput) _this.firstInput = input;
        question.input = input;
        question.re = new RegExp(question.validation);

        if (options.form.formType != 'survey' && question.maxLength < 900) {
            input.setAttribute('placeholder', question.text);
            return [input];
        }

        return [label, input];
    }

    function createMultiCheckboxes(question) {
        var children = [];
        var inputs = [];

        if (options.form.formType != 'call2action') {
            var label = dom.create({
                element: 'label',
                class: labelClass,
                textContent: question.gdpr | question.consent ? '' : question.text,
            });

            children.push(label);
        }

        for (var i = 0, len = question.options.length; i < len; i++) {
            var option = question.options[i];

            var elements = createMultiCheckboxesOption(question, option);

            children.push(elements.wrapper);
            inputs.push(elements.input);
        }

        question.input = inputs;
        return children;
    }

    function createMultiCheckboxesOption(question, option) {
        var input = dom.create({
            element: 'input',
            attributes: {
                type: 'checkbox',
                id: option.id,
                'touch-action': 'pan-y',
            },
            events: {
                change: onChange.bind(question),
                click: function (e) {
                    e.stopPropagation();
                }
            }
        });

        if (option.hideGDPRCheckbox) dom.hide(input);

        if (question.prefill) {
            for (var i = 0, length = question.prefill.length; i < length; i++) {
                if (question.prefill[i] == option.id) input.checked = true;
            }
        }

        if (!_this.firstInput) _this.firstInput = input;
        if (options.form.formType == 'call2action') {

            var data = {}

            try {
                data = JSON.parse(option.label);
            }
            catch (e) {
                //nomnomnom
            }

            var type = option.reference.indexOf(call2ActionTypes.survey) > -1 ? call2ActionTypes.survey :
                data[call2ActionTypes.url] ? call2ActionTypes.url :
                    data[call2ActionTypes.attend] ? call2ActionTypes.attend :
                        call2ActionTypes.none;

            switch (type) {
                case call2ActionTypes.attend:
                case call2ActionTypes.none:
                    break;
                default:
                    input.addEventListener('change', createCall2Action(type, option, data, input, question));
            }
        }

        var label = dom.create({
            element: 'label',
            class: labelClass,
            attributes: {
                'for': option.id,
            },
        });

        if (question.prefill.indexOf(option.text) > -1) input.checked = true;

        if (question.gdpr | question.consent) {

            label.innerHTML = option.text;
            var elements = label.getElementsByTagName('a');

            for (var i = 0; i < elements.length; i++) {
                elements[i].addEventListener('click', function (e) {
                    e.stopPropagation();
                });
            }

        } else {
            label.textContent = option.text;
        }


        dom.focusable(input);

        var wrapper = dom.create({
            element: 'div',
            class: 'checkbox',
            children: [
                input,
                dom.create({
                    element: 'span',
                    class: 'icon ' + (option.hideGDPRCheckbox ? 'hidden' : ''),
                    events: {
                        click: function (e) {
                            e.preventDefault();
                            e.stopPropagation();
                            input.click();
                        }
                    }
                }),
                label
            ],
            events: {
                click: function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    input.click();
                }
            }
        });

        if (options.form.formType == 'call2action') {
            wrapper.classList.add('bordered');
            input.addEventListener('change', function (e) {
                if (input.checked) {
                    wrapper.classList.add('checked');
                } else {
                    wrapper.classList.remove('checked');
                }
            });
        }

        return {
            wrapper: wrapper,
            input: input,
        }
    }

    function hide() {
        dom.hide(_this.elements.errorMessage, true);
        dom.hide(_this.elements.postSubmitMessage, true);
        dom.hide(_this.elements.submitIcon, true);
        dom.hide(_this.elements.form, true);
        dom.hide(_this.elements.cancelBtn, true);
    }

    function showPostExamReport(config, result) {
        hide();

        dom.show(_this.elements.postExamReportBtn);

        if (_this.elements.formContainer) {
            _this.elements.formContainer.parentElement.scrollTop = 0;
        }


        _this.elements.postExamReportLabel.appendChild(dom.create({
            element: 'div',
            class: 'form-group',
            textContent: config.label,
        }));

        if (config.showGivenAnswer) {
            for (var i = 0, length = result.length; i < length; i++) {
                var question = result[i];

                var el = dom.create({ element: 'div', class: 'form-group' });
                var myAnswer = dom.create({ element: 'div', textContent: question.myAnswer });
                _this.elements.postExamReportLabel.appendChild(el)

                var label = dom.create({
                    element: 'div',
                    textContent: question.label,
                });

                var formGroup = dom.create({
                    element: 'div',
                    class: 'form-group',
                });


                for (var j = 0; j < question.options.length; j++) {
                    var option = question.options[j];
                    var answer = dom.create({
                        element: 'div',
                        class: 'answer',
                        textContent: option.text,
                    });

                    if (config.showGivenAnswer && option.mine) answer.classList.add('mine');
                    if (option.correct && config.showCorrectAnswer) answer.classList.add('correct');
                    if (!option.correct && config.showIncorrectAnswer && option.mine) answer.classList.add('incorrect');

                    formGroup.appendChild(answer);
                }

                var el = dom.create({
                    element: 'div',
                    class: 'form-group question',
                    children: [label, formGroup],
                });

                _this.elements.postExamReportLabel.appendChild(el);
            }
        } else {
            dom.hide(_this.elements.postExamReportBtn);
        }

        dom.fadeIn(_this.elements.postExamReport);
    }

    function showForm() {
        hide();
        dom.fadeIn(_this.elements.form);
        dom.fadeIn(_this.elements.cancelBtn);

        for (var key in _this.questions) {
            var input = _this.questions[key].input;
            if (Array.isArray(input)) {
                for (var i = 0; i < input.length; i++) {
                    input[i].checked = false;
                }
            } else {
                input.value = '';
            }

            onChange.call(_this.questions[key]);
        }
    }

    function showPostSubmit() {
        hide();
        dom.fadeIn(_this.elements.postSubmitMessage);
    }

    function showError() {
        hide();
        dom.fadeIn(_this.elements.errorMessage);
    }

    function getGDPRRequiredError(question, elements) {
        if (!question.label || question.label.indexOf('gdpr') == -1) return false;
        for (var i = 0, len = elements.length; i < len; i++) {
            if (!elements[i].checked) return true;
        }
        return false;
    }

    function getMultiAnswer(elements) {
        var answer = '';
        var first = true;
        for (var i = 0, len = elements.length; i < len; i++) {
            var element = elements[i];
            if (element.checked) {
                if (!first) answer += '~';
                answer += element.id;
                first = false;
            }
        }
        return answer;
    }

    function onChange(e) {
        var answer;

        if (
            this.type == questionTypes.multi ||
            this.type == questionTypes.multiString ||
            ((this.type == questionTypes.single || this.type == questionTypes.singleString) && expandedForms.indexOf(options.form.formType || options.form.type) > -1)
        ) {
            answer = getMultiAnswer(this.input);
        } else {
            answer = this.input.value;
        }

        this.validationError = this.validation && !answer.match(this.validation);
        this.requiredError = (this.mandatory && !answer) || getGDPRRequiredError(this, this.input);

        if (this.validationError || this.requiredError) {
            this.formGroup.classList.add('has-error');
            errors.push(this.id);
        } else {
            this.formGroup.classList.remove('has-error');
            var i;
            while ((i = errors.indexOf(this.id)) > -1) {
                errors.splice(i, 1);
            }
        }

        if (errors.length > 0) {
            _this.elements.submitBtn.disabled = true;
        } else {
            _this.elements.submitBtn.disabled = false;
        }

        _this.answers[this.id] = answer;

        if (options.form.formType == 'call2action' && errors.length == 0 && this.options.length == 1 && answer) {
            submit(e);
        }
    }
}

},{"../../../sdk/bootstrapping.js":19,"../../../sdk/config.js":21,"../../../sdk/dom.js":24,"../../../sdk/http.js":26,"../../../sdk/localStorage.js":28}],6:[function(require,module,exports){
var bootstrapping = require('./bootstrapping.js');
var http = require('./http.js');
var configService = require('./configService.js');
var config = require('./config.js');
var browserSniffing = require('./browserSniffing.js');
var pipelines = require('./pipelines.js')

var params = bootstrapping.query;

module.exports = Api;

function Api(options) {

    if (!options.cic) throw new Error('options.cic is undefined');

    var _this = this;

    this.cic = options.cic;
    this.getI18N = getI18N;
    this.getInfo = getInfo;

    function getI18N(language) {

        if (bootstrapping.query.cic && bootstrapping.query.cic.i18n) {
            console.log('api', 'waiting on cic');
            return new Promise(function (resolve, reject) {
                _this.cic.on('i18n', function (e) {
                    console.log('api', 'cic i18n received');
                    _this.i18n = e.i18n;
                    resolve(e.i18n);
                });
            });
        }

        return configService.get(((options.i18n && options.i18n.namespace) || 'root.sdk.player.i18n.{language}').replace('{language}', language || bootstrapping.language)).then(function (i18n) {
            _this.i18n = i18n;
            return i18n;
        });
    }

    function getIsAdmin(id) {
        return http.get(config.url.accessRules.replace('{id}', id) + '/id').json().then(function (accessrules) {
            return accessrules.isAdmin;
        });
    }

    function getInfo(id) {

        if (bootstrapping.query.cic && bootstrapping.query.cic.info) {
            return new Promise(function (resolve, reject) {
                _this.cic.on('info', function (e) {
                    console.log('api', 'cic info received');
                    _this.info = e.info;
                    resolve(e.info);
                });
            });
        }

        return http.get(config.url.player.replace('{id}', id || params.id)).json().then(function (info) {
            if (false) {
                info.attend = config.domain + info.attend;
                info.resources = config.domain + info.resources;
            }

            info.slideViewer = false;

            info.videoSettings = info.videoSettings || {};
            if (info.videoSettings.dvr === undefined) info.videoSettings.dvr = true;
            if (info.videoSettings.scrubbing === undefined) info.videoSettings.scrubbing = true;
            if (info.videoSettings.videoPipeline === undefined) info.videoSettings.videoPipeline = pipelines.legacy;

            info.isConference = bootstrapping.query.pipeline == pipelines.rivetConference || info.videoSettings.videoPipeline == pipelines.rivetConference;

            if (config.isAdmin
                || bootstrapping.query.pipeline == pipelines.legacy
                || bootstrapping.query.pipeline == pipelines.rivetConference
                || info.phase == 'onDemand'
                || browserSniffing.IPhone) {

                info.pipeline = pipelines.legacy;

            } else if (bootstrapping.query.pipeline) {

                info.pipeline = bootstrapping.query.pipeline;

            } else {

                info.pipeline = info.videoSettings.videoPipeline;

            }

            var defaultEnvironment = "prod";
            info.pipelineEnvironment = info.tags.environment && info.tags.environment[0] ? info.tags.environment[0] : defaultEnvironment;

            for (var i = 0, length = info.sources.length; i < length; i++) {
                var source = info.sources[i];

                switch (info.pipeline) {

                    case pipelines.rivetLiveStream:

                        var proxyDomain = config.url.rivet.proxy.replace('{environment}', info.pipelineEnvironment);
                        var proxyRoot = proxyDomain + '/api/session/' + info.webcastCode;

                        source.playable = proxyRoot + '/playable';
                        source.started = proxyRoot + '/started';
                        source.created = proxyRoot + '/created';
                        source.src = config.domain + source.src;
                        source.newPipelineSrc = proxyRoot + '/authorizedplaybackurl';

                        break;

                    default:
                        source.playable = config.domain + source.playable;
                        source.started = config.domain + source.started;
                        source.created = config.domain + source.created;
                        source.src = config.domain + source.src;
                        break;
                }

                source.events = config.domain + source.events;
                source.thumbFormat = config.domain + source.thumbFormat;
                source.thumbInfo = config.domain + source.thumbInfo;
                source.toOffset = config.domain + source.toOffset;
                source.toWalltime = config.domain + source.toWalltime;
                source.watched = config.domain + source.watched;
                source.type = 'application/x-mpegurl';

                if (source.streamType == 'FakeRealtime') {
                    source.type = 'FakeRealtime';
                    info.slideViewer = true;
                }
            }

            info.autoplay = !!info.tags.autoplay;
            info.repeat = !!info.tags.repeat;
            info.forceSubs = !!info.tags.forceSubs;
            info.liveSubtitles = !!info.tags.liveSubtitles;

            info.dvr = !!bootstrapping.query.dvr && !!info.videoSettings.dvr;
            info.scrubbing = !!bootstrapping.query.scrubbing && !!info.videoSettings.scrubbing;

            info.p2p = !!bootstrapping.query.p2p;

            _this.info = info;

            info.durationInMinutes = 0;
            try {
                if (info.duration) {
                    var split = info.duration.split(':');

                    info.durationInMinutes = parseInt(split[0]) * 60 + parseInt(split[1]);
                }
            } catch (e) {
                console.log('could not parse info.duration', e);
            }

            return configService.get('root.customer.' + info.customer.code, '$filter=Key%20eq%20%27setting.google.analytics.key%27').then(function (config) {

                info.customer.config = config;

                return getIsAdmin(info.id).then(function (isAdmin) {
                    info.isAdmin = isAdmin;
                    if (isAdmin) {
                        info.identityProviders = [];
                    }
                    return info;
                });
            });
        });
    }
}


},{"./bootstrapping.js":19,"./browserSniffing.js":20,"./config.js":21,"./configService.js":22,"./http.js":26,"./pipelines.js":30}],7:[function(require,module,exports){
var Identity = require('./auth/Identity.js');
var AccessRules = require('./auth/AccessRules.js');

module.exports = Auth;

function Auth(options) {
    this.customerCode = options.customerCode;
    this.webcastId = options.webcastId;

    this.identity = new Identity({
        customerCode: options.customerCode,
        identificationToken: options.identificationToken,
        provider: options.provider,
    });

    this.accessRules = new AccessRules({
        webcastId: options.webcastId,
        identity: this.identity,        
    });
}
},{"./auth/AccessRules.js":13,"./auth/Identity.js":14}],8:[function(require,module,exports){
var EventEmitter = require('./EventEmitter.js');
var guid = require('./guid.js');

module.exports = CrossIframeCommunication;


function CrossIframeCommunication(key) {
    var _this = this;
    var eventEmitter = new EventEmitter(true);
    var iFrames = [];
    var parents = [];

    this.id = guid.v4();
    this.postMessage = postMessage;
    this.emit = emit;
    this.on = eventEmitter.on;
    this.one = eventEmitter.on;
    this.subscribeIframe = subscribeIframe;
    this.destroy = destroy;

    function postMessage(target, event, data) {
        var message = {
            sender: _this.id,
            key: key,
            event: event,
            data: data,
        };

        try {
            if (target) target.postMessage(message, '*');
        } catch (e) {
            console.log(e, message);
        }
    }

    function emit(event, data) {

        for (var i = 0, length = iFrames.length; i < length; i++) {
            postMessage(iFrames[i].contentWindow, event, data);
        }

        for (var i = 0, length = parents.length; i < length; i++) {
            postMessage(parents[i], event, data);
        }

        return eventEmitter.emit(event, data);
    }

    window.addEventListener('message', onMessage);

    postMessage(window.opener || window.parent, 'ready');

    function onMessage(e) {
        try {
            var obj = e.data;

            if (!obj.key || obj.key == key && obj.sender != _this.id) {
                emit(obj.event, obj.data);
            }
        } catch (e) {
            console.error(e);
            //nomnomnom
        }
    }

    function subscribeIframe(element) {
        iFrames.push(element);
    }

    function subscribeParent(element) {
        parents.push(element);
    }

    function destroy() {
        window.removeEventListener('message', onMessage);
        iFrames = null;
        parents = null;
        eventEmitter = null;
    }
}


},{"./EventEmitter.js":9,"./guid.js":25}],9:[function(require,module,exports){
/**
@class
@alias cwc.sdk.EventEmitter
@description emit events
@constructor
@property {object} events list of registered events
*/
function EventEmitter(storeEvents) {
    var _this = this;

    this.events = {};
    this.callbacks = {};
    this.emit = emit;
    this.on = on;
    this.one = one;
    this.destroy = destroy;

    /**
    @method
    @alias cwc.sdk.EventEmitter.emit
    @description emit an event
    @param {string} event name of event
    @param {object} data will be passed to event listeners
    @return {array} results
    */
    function emit(event, data) {

        if (storeEvents) {
            var events = _this.events[event];
            if (!events) {
                events = [];
                _this.events[event] = events;
            }
            events.push(data);
        }

        var callbacks = _this.callbacks[event];
        var results = [];
        if (callbacks) {
            for (var i = callbacks.length - 1; i >= 0; --i) {
                var callback = callbacks[i];
                results.push(callback(data));
                if (callback.once) {
                    callback.remove();
                }
            }
        }
        return results;
    }

    /**
    @method
    @alias cwc.sdk.EventEmitter.on
    @description listen to an event
    @param {string} event name of event
    @param {function} callback will be called when an event is emitted
    @return {function} cancelToken calling this function will unregister this listener
    */
    function on(event, callback, once) {
        var callbacks = _this.callbacks[event];
        if (!callbacks) {
            callbacks = [];
            _this.callbacks[event] = callbacks;
        }

        callbacks.push(callback);

        callback.once = once;
        callback.remove = function () {
            var index = callbacks.indexOf(callback);
            if (index > -1) callbacks.splice(index, 1);
        }

        if (storeEvents) {
            var events = _this.events[event];
            if (events) {
                for (var i = 0, length = events.length; i < length; i++) {
                    callback(events[i]);
                    if (once) {
                        callback.remove();
                        break;
                    }
                }
            }
        }

        return callback.remove;
    }

    /**
    @method
    @alias cwc.sdk.EventEmitter.one
    @description listen to an event once
    @param {string} event name of event
    @param {function} callback will be called when an event is emitted (one time only)
    */
    function one(event, callback) {
        return on(event, callback, true);
    }

    function destroy() {
        _this.events = {};
    }
}


module.exports = EventEmitter;
},{}],10:[function(require,module,exports){
var log = require('./log.js');
var dom = require('./dom.js');
var config = require('./config.js');
var browserSniffing = require('./browserSniffing.js');

module.exports = GoogleAnalytics;

function GoogleAnalytics(keys) {

    this.sendVirtualPageView = sendVirtualPageView;

    var promises = {
        script: null,
    }

    function loadScript() {
        if (!promises.script) {
            promises.script = dom.loadScript(config.src.analytics).then(function () {
                if (ga) {
                    for (var i = 0, length = keys.length; i < length; i++) {
                        var key = keys[i];
                        ga('create', key, 'auto', key.replace(/-/g, ''));
                        ga('set', 'anonymizeIp', true);
                    }
                }
            });
        }
        return promises.script;
    }

    function sendVirtualPageView(properties) {
        if (keys.length == 0) return;

        //ios 17 comes with advanced tracking protection, which breaks hlsjs when sending ga calls
        //skip analytics if thats the case
        if (browserSniffing.ios17) return;
        loadScript().then(function () {
            if (ga) {
                properties = properties || {};
                properties.page = properties.page || location.pathname;


                for (var i = 0, length = keys.length; i < length; i++) {
                    ga(keys[i].replace(/-/g, '') + '.send', 'pageview', properties);
                }
            }
        });
    }
}
},{"./browserSniffing.js":20,"./config.js":21,"./dom.js":24,"./log.js":29}],11:[function(require,module,exports){
var http = require('./http.js');
var config = require('./config.js');

module.exports = Poster;

var qualities = {
    p80: '80p',
    p160: '160p',
    original: 'original',
}

function Poster(urls) {
    var _this = this;

    this.promises = {};
    this.writeToDom = writeToDom;

    function writeToDom(options) {
        options = options || {};
        return get(options.quality).then(function (url) {
            var css = document.createElement('style');
            css.innerHTML = '.{class} { background-image: url({url}); background-size: {background-size}; background-position:center; background-repeat: no-repeat; }'
                .replace('{class}', options.class || 'poster')
                .replace('{background-size}', options.size || 'cover')
                .replace('{url}', url);
            document.head.appendChild(css);
        });
    }

    function get(quality) {
        quality = quality || qualities.original;

        var promise = _this.promises[quality];

        if (!promise) {
            promise = new Promise(function (resolve, reject) {
                _this.promises[quality] = promise;
                recursiveGet(resolve, reject, quality, 0);
            });
        }

        return promise;
    }

    function recursiveGet(resolve, reject, quality, index) {
        if (index >= urls.length) {
            reject(new Error('no valid poster found'));
            return;
        }
        var uri = urls[index].replace('{quality}', quality);

        if (false) {
            uri = config.domain + uri;
        }

        http.get(uri).raw().then(function () {
            resolve(uri);
        })['catch'](function () {
            recursiveGet(resolve, reject, quality, ++index);
        });
    }
}

Poster.qualities = qualities;
Poster.prototype.qualities = qualities;
},{"./config.js":21,"./http.js":26}],12:[function(require,module,exports){
module.exports = Tokens;

function Tokens(id, tokens) {
    var _this = this;

    this.legacyPulseToken = tokens.token;
    this.cloudFrontTokens = tokens.readTokens;
    this.getTokenForUrl = getTokenForUrl;

    function getTokenForUrl(url) {
        var tokens = _this.cloudFrontTokens[isSecure(url) ? 'ssl' : 'non-ssl'];

        if (url.indexOf('/players') > -1) {
            return tokens.players;
        } else if (url.indexOf('/playlist') > -1) {
            return tokens.playlist;
        } else {
            return tokens[id];
        }
    }

    function isSecure(url) {
        if (url.indexOf('https://') > -1) return true;
        if (window.location.href.indexOf('https://') > -1) return true;
        return false;
    }
}
},{}],13:[function(require,module,exports){
var http = require('../http.js');
var config = require('../config.js');
var localStorage = require('../localStorage.js');
var log = require('../log.js');
var guid = require('../guid.js');
var EventEmitter = require('../EventEmitter.js');
var Tokens = require('../Tokens.js');

module.exports = AccessRules;

function AccessRules(options) {
    if (!options.webcastId) throw new Error('webcastId is not defined');
    if (!options.identity) throw new Error('identity is not defined');

    var _this = this;

    this.webcastId = options.webcastId;
    this.identity = options.identity;
    this.allowUserInteraction = options.allowUserInteraction;
    this.tokens = null;


    var eventEmitter = new EventEmitter(true);

    var deferred = {
        hasForms: Promise.defer(),
        tokens: Promise.defer(),
    }

    var promises = {
        hasForms: deferred.hasForms.promise,
        tokens: Promise.race([
            deferred.tokens.promise,
            _this.identity.getIdentificationToken().then(function (identificationToken) {
                return runAccessRules(_this.webcastId, identificationToken).then(function (tokens) {
                    _this.tokens = tokens;
                    return tokens;
                });
            })
        ]),
    }

    this.getTokens = getTokens;
    this.hasForms = hasForms;
    this.setTokens = setTokens;

    this.on = eventEmitter.on;
    this.one = eventEmitter.one;

    this.errors = [];

    function setTokens(tokens) {
        _this.tokens = tokens;
        deferred.tokens.resolve(tokens);
    }

    function getAccessRule(id, identificationToken) {
        return http.get(config.url.accessRules.replace('{id}', id), {
            headers: {
                'X-Authorization': identificationToken,
            }
        }).json();
    }

    function postAccessRule(url, identificationToken, form) {
        return http.post(url, form, {
            headers: {
                'X-Authorization': identificationToken,
            }
        }).form();
    }

    function getTokens() {
        return promises.tokens;
    }

    function hasForms() {
        return promises.hasForms;
    }

    function runAccessRules(id, identificationToken) {
        return getAccessRule(id, identificationToken).then(function (accessRule) {
            if (accessRule.token) {
                return {
                    legacyPulseToken: accessRule.token,
                    cloudFrontTokens: accessRule.readTokens,
                }
            } else {
                return requestForm(id, identificationToken, accessRule);
            }
        }, function (error) {
            _this.errors.push(error);

            if (_this.errors.length > 5) {
                log.error('error.player.accessrules.failed');
            } else {
                return runAccessRules(id, identificationToken);
            }
        });
    }

    function requestForm(id, identificationToken, accessRule) {
        deferred.hasForms.resolve(true);

        if (!accessRule.form.id) accessRule.form.id = guid.v4();

        return new Promise(function (resolve, reject) {

            accessRule.form.submit = function (answers) {
                var post = postAccessRule(accessRule.postUrl, identificationToken, answers);
                resolve(post.then(function () {
                    return runAccessRules(id, identificationToken);
                }, function () {
                    return runAccessRules(id, identificationToken);
                }));
                return post;
            }

            eventEmitter.emit('form', { form: accessRule.form });
        });
    }
}
},{"../EventEmitter.js":9,"../Tokens.js":12,"../config.js":21,"../guid.js":25,"../http.js":26,"../localStorage.js":28,"../log.js":29}],14:[function(require,module,exports){
var localStorage = require('../localStorage.js');
var http = require('../http.js');
var config = require('../config.js');
var EventEmitter = require('../EventEmitter.js');

module.exports = Identity;

function Identity(options) {
    console.log('identity', 'options', options);

    if (!options.customerCode) throw new Error('customercode is not defined');

    this.identificationToken = options.identificationToken;
    this.customerCode = options.customerCode;
    this.allowUserInteraction = options.allowUserInteraction;
    
    var _this = this;
    var eventEmitter = new EventEmitter(true);

    var deferred = {
        identityProvider: Promise.defer(),
        identificationToken: Promise.defer(),
    }

    var promises = {
        identityProvider: deferred.identityProvider.promise,
        identificationToken: deferred.identificationToken.promise,
    }

    this.getIdentificationToken = getIdentificationToken;
    this.setIdentificationToken = setIdentificationToken;
    this.setProvider = setProvider;
    this.on = eventEmitter.on;

    if (options.provider) setProvider(options.provider);
    
    if (_this.identificationToken) {
        refreshIdentificationToken(_this.identificationToken).then(setIdentificationToken);
    } else {
        runResolver().then(setIdentificationToken);
    }

    function setProvider(provider) {
        _this.identityProvider = provider;
        deferred.identityProvider.resolve(provider);
    }

    function getIdentificationToken() {
        return promises.identificationToken;
    }

    function refreshIdentificationToken(identificationToken) {
        return http.get(config.url.refreshToken.replace('{token}', _this.identificationToken)).json().then(function (result) {
            return result.identificationToken;
        })['catch'](function (e) {
            console.log(e);
            runResolver();
        });
    }

    function runResolver() {
        console.log('awaiting resolver');
        if (!_this.identityProvider) eventEmitter.emit('provider:request', { setProvider: setProvider });
        return promises.identityProvider.then(function (provider) {
            return provider.getIdentificationToken();
        });
    }

    function setIdentificationToken(identificationToken) {
        _this.identificationToken = identificationToken;
        localStorage.set(_this.customerCode, identificationToken);
        deferred.identificationToken.resolve(identificationToken);
        return identificationToken;
    }
}


},{"../EventEmitter.js":9,"../config.js":21,"../http.js":26,"../localStorage.js":28}],15:[function(require,module,exports){
var http = require('../../http.js');
var config = require('../../config.js');
var log = require('../../log.js');
var CIC = require('../../CrossIframeCommunication');

module.exports = BlunderboreAuth;

function BlunderboreAuth(options) {

    if (!options.provider) throw new Error('options.provider is undefined');
    if (!options.customerCode) throw new Error('options.customerCode is undefined');
    if (!options.webcastId) throw new Error('options.webcastId is undefined');
    //if (!options.element && !options.newWindow) throw new Error('either options.element or options.newWindow must be set');

    var cic = new CIC('blunderboreAuth/callback');

    this.getIdentificationToken = getIdentificationToken;
    this.userInteractionRequired = userInteractionRequired;

    function userInteractionRequired() {
        return options.newWindow;
    }

    function getIdentificationToken() {
        //alert('auth provider requesting identification token from blunderbore auth');
        var url = getUrl();
        var iframe, clientWindow;
        if (options.newWindow) {
            clientWindow = window.open(url, '_blank');
        } else {
            iframe = document.createElement('iframe');
            iframe.src = url;
            iframe.style.position = 'absolute';
            iframe.style.left = '0';
            iframe.style.top = '0';
            iframe.style.width = '100%';
            iframe.style.height = '100%';
            document.documentElement.appendChild(iframe);
        }

        return new Promise(function (resolve, reject) {
            cic.on('identificationToken', function (e) {
                //window.alert('auth provider received identification token from callback.js: ' + e.identificationToken);
                resolve(e.identificationToken);
                try {
                    //window.alert('auth provider attempting to close callback.js window');
                    if (clientWindow) clientWindow.close();
                    if (iframe) document.documentElement.removeChild(iframe);
                } catch (e) {
                    log.error(e.message);
                }
            });
        });
    }

    function getUrl() {
        return config.url.auth.provider
            .replace('{provider}', options.provider)
            .replace('{customerCode}', options.customerCode)
            .replace('{successRedirect}', encodeURIComponent(config.url.auth.successRedirect))
            .replace('{failureRedirect}', encodeURIComponent(config.url.auth.failureRedirect));
    }
}
},{"../../CrossIframeCommunication":8,"../../config.js":21,"../../http.js":26,"../../log.js":29}],16:[function(require,module,exports){
var VisitorProvider = require('./Visitor.js');
var TokenProvider = require('./Token.js');
var BlunderboreAuthProvider = require('./BlunderboreAuth.js');

module.exports = Factory;

var providers = {
    token: 'token',
    google: 'google',
    visitor: 'visitor',
    saml: 'saml',
}

function Factory(options) {
    var _this = this;
    this.info = options.info;
    this.createProvider = createProvider;

    function createProvider(type, options) {
        switch (type) {
            case providers.token:
                return new TokenProvider(options.identificationToken);
            case providers.visitor:
                return new VisitorProvider(_this.info.id);
            default:
                return new BlunderboreAuthProvider({
                    provider: type,
                    newWindow: true,
                    customerCode: _this.info.customerCode,
                    webcastId: _this.info.id,
                });
        }
    }
}
},{"./BlunderboreAuth.js":15,"./Token.js":17,"./Visitor.js":18}],17:[function(require,module,exports){
module.exports = Token;

function Token(identificationToken) {

    if (!identificationToken) throw new Error('identificationToken is undefined');

    this.getIdentificationToken = getIdentificationToken;
    this.userInteractionRequired = userInteractionRequired;

    function userInteractionRequired() {
        return false;
    }


    function getIdentificationToken() {
        return Promise.resolve(identificationToken);
    }
}
},{}],18:[function(require,module,exports){
var http = require('../../http.js');
var config = require('../../config.js');

module.exports = Visitor;

function Visitor(webcastId) {

    if (!webcastId) throw new Error('webcastId is undefined');

    this.getIdentificationToken = getIdentificationToken;
    this.userInteractionRequired = userInteractionRequired;

    function userInteractionRequired() {
        return false;
    }
    
    function getIdentificationToken() {
        return http.get(config.url.accessRules.replace('{id}', webcastId) + '/token?r=' + new Date().getTime()).json().then(function (result) {
            return result.identificationToken;
        });
    }
}
},{"../../config.js":21,"../../http.js":26}],19:[function(require,module,exports){
var browserSniffing = require('./browserSniffing.js');
var log = require('./log.js');
var pipelines = require('./pipelines.js');

var minFontSize = 8;
var baseFontSize = 28;
var baseScreenWidth = 1080 / 9;
var fontRatio = (baseFontSize - minFontSize) / baseScreenWidth;

var params = getQueryParameters();
var query = getOptions(params);
var language = query.language || getLanguage();

if (query.debug) {
    log.hijackConsole();
}

var api = {
    registerFontSizeListener: registerFontSizeListener,
    query: query,
    language: language,
    getDisplay: function (displayOptions) {
        return getDisplayOptions(params.display, displayOptions);
    }
}

module.exports = api;

document.body.onload = function () {
    var el = document.getElementById('ConnectiveDocSignExtentionInstalled');
    if (el) el.remove();
}


function getQueryParameters(str) {
    return (str || document.location.search).replace(/(^\?)/, '').split("&").map(function (n) { return n = n.split("="), this[n[0]] = decodeURIComponent(n[1]), this }.bind({}))[0];
}

function getLanguage() {

    var lang = window.navigator.languages ? window.navigator.languages[0] : null;
    lang = lang || window.navigator.language || window.navigator.browserLanguage || window.navigator.userLanguage;
    if (lang.indexOf('-') !== -1) lang = lang.split('-')[0];
    if (lang.indexOf('_') !== -1) lang = lang.split('_')[0];
    return lang;
}

function registerFontSizeListener() {

    setFontSize();

    window.addEventListener('resize', setFontSize);
}

function setFontSize() {
    var fontSize;
    var width = window.innerWidth / 16;
    var height = window.innerHeight / 9;

    if (width > height) {
        fontSize = height * fontRatio;
    } else {
        fontSize = width * fontRatio;
    }

    document.body.style.fontSize = Math.ceil(minFontSize + fontSize) + 'px';
}

function getOptions(query) {
    var options = query;

    if (options.debug !== undefined) {
        options.debug = true;
    }

    if (options.offsets) {
        options.offsets = options.offsets.split(',');
    }

    if (options.start) {
        options.start = parseInt(options.start);
    }

    if (options.autoplay !== undefined) {
        options.autoplay = true;
    }

    if (options.repeat !== undefined) {
        options.repeat = true;
    }

    if (options.skipWebcastLink !== undefined) {
        options.skipWebcastLink = true;
    }

    if (!(options.pipeline && pipelines[options.pipeline])) {
        options.pipeline = undefined;
    }

    if (options.transparent !== undefined) {
        options.transparent = true;
    }

    if (options.autosubmit !== undefined) {
        options.autosubmit = true;
    }

    if (options.liveSubtitleDelay !== undefined) {
        options.liveSubtitleDelay = parseFloat(options.liveSubtitleDelay);
    }

    var el = document.createElement('style');

    if (options.customBtnColor) {
        options.customBtnColor = options.customBtnColor.split(',');
        options.customBtnColor = {
            default: options.customBtnColor[0],
            disabled: options.customBtnColor[1],
        }

        el.innerHTML += '.btn-bright { background-color: #' + options.customBtnColor.default + '; } '
        el.innerHTML += '.btn-bright:disabled { background-color: #' + options.customBtnColor.disabled + '; } '
    }

    if (options.customVideoAndSlideBackgroundColor) {
        el.innerHTML += '.video.videoandslide { background-color: #' + options.customVideoAndSlideBackgroundColor.replace('#', '') + '; }';
    }

    document.head.appendChild(el);

    if (options.p2p !== undefined || window.location.href.indexOf('/p2pplayer') > -1) {
        options.p2p = true;
    }

    if (options.p2pProxy !== undefined && (browserSniffing.IE || browserSniffing.Edge)) {
        options.p2pProxy = true;
    }

    if (options.cic) {
        var cic = options.cic.split(',');
        options.cic = {};
        for (var i = 0; i < cic.length; i++) {
            options.cic[cic[i]] = true;
        }
    }

    var emit = {};
    if (options.emit) {
        var emit = options.emit.split(',');
        options.emit = {};
        for (var i = 0; i < emit.length; i++) {
            options.emit[emit[i]] = true;
        }
    } else {
        options.emit = {};
    }

    options.dvr = options.dvr == undefined ? true : options.dvr == "true";
    options.scrubbing = options.scrubbing == undefined ? true : options.scrubbing == "true";
    options.newWindow = browserSniffing.webView ? false : options.newWindow == undefined ? true : options.newWindow == "true";

    if (options.embed) {
        options.embed = options.embed.split(',');
    }

    return options;
}

function getDisplayOptions(options, displayOptions) {
    var display = {}

    if (options === undefined) {
        options = displayOptions.all;
    }
    options = parseInt(options);

    for (var key in displayOptions) {
        display[key] = !!((displayOptions[key] & options) == displayOptions[key]);
    }

    return display;
}
},{"./browserSniffing.js":20,"./log.js":29,"./pipelines.js":30}],20:[function(require,module,exports){
(function (global){
var USER_AGENT = navigator.userAgent;
var IPAD = /iPad/i.test(USER_AGENT);
var IPHONE = /iPhone/i.test(USER_AGENT) && !IPAD;
var IPOD = /iPod/i.test(USER_AGENT);
var IOS = IPHONE || IPAD || IPOD;
var MAC = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
var EDGE = navigator.appVersion.indexOf('Edge') > -1 || navigator.appVersion.indexOf('Edg') > -1;
var EDGECHROMIUM = navigator.appVersion.indexOf('Edg/') > -1;
var IE = navigator.appVersion.indexOf('MSIE') > -1 || navigator.appVersion.indexOf('Trident') > -1;
var WINDOWSPHONE = navigator.appVersion.indexOf('Windows Phone') > -1;
var SAFARI = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
var MOBILE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(navigator.userAgent || navigator.vendor || window.opera) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test((navigator.userAgent || navigator.vendor || window.opera).substr(0, 4));
var CHROMEIOS = /CriOS/i.test(USER_AGENT);

var ua = USER_AGENT;
var os = _detectOS(ua);
var browser = _detectBrowser(ua);
var browserVersion = _detectBrowserVersion(ua, browser);
var webView = _isWebView(ua, os, browser, browserVersion, {});
var ios17 = SAFARI && parseInt(browserVersion.split('.')[0]) >= 17


var api = {
    IOS: IOS,
    IPad: IPAD,
    IPhone: IPHONE,
    IPod: IPOD,
    MAC: MAC,
    Edge: EDGE,
    EdgeChromium: EDGECHROMIUM,
    IE: IE,
    WindowsPhone: WINDOWSPHONE,
    Safari: SAFARI,
    mobile: MOBILE,
    ChromeIOS: CHROMEIOS,
    webView: webView,
    os: os,
    osVersion: getIOSVersion(),
    browser: browser,
    browserVersion: browserVersion,
    ios17: ios17
}

module.exports = api;

function _detectOS(ua) {
    switch (true) {
        case /Android/.test(ua): return "Android";
        case /iPhone|iPad|iPod/.test(ua): return "iOS";
        case /Windows/.test(ua): return "Windows";
        case /Mac OS X/.test(ua): return "Mac";
        case /CrOS/.test(ua): return "Chrome OS";
        case /Firefox/.test(ua): return "Firefox OS";
    }
    return "";
}

function _detectBrowser(ua) {
    var android = /Android/.test(ua);

    switch (true) {
        case /CriOS/.test(ua): return "Chrome for iOS"; // https://developer.chrome.com/multidevice/user-agent
        case /Edge/.test(ua): return "Edge";
        case android && /Silk\//.test(ua): return "Silk"; // Kidle Silk browser
        case /Chrome/.test(ua): return "Chrome";
        case /Firefox/.test(ua): return "Firefox";
        case android: return "AOSP"; // AOSP stock browser
        case /MSIE|Trident/.test(ua): return "IE";
        case /Safari\//.test(ua): return "Safari";
        case /AppleWebKit/.test(ua): return "WebKit";
    }
    return "";
}

function _detectBrowserVersion(ua, browser) {
    switch (browser) {
        case "Chrome for iOS": return _getVersion(ua, "CriOS/");
        case "Edge": return _getVersion(ua, "Edge/");
        case "Chrome": return _getVersion(ua, "Chrome/");
        case "Firefox": return _getVersion(ua, "Firefox/");
        case "Silk": return _getVersion(ua, "Silk/");
        case "AOSP": return _getVersion(ua, "Version/");
        case "IE": return /IEMobile/.test(ua) ? _getVersion(ua, "IEMobile/")
            : /MSIE/.test(ua) ? _getVersion(ua, "MSIE ") // IE 10
                : _getVersion(ua, "rv:");  // IE 11
        case "Safari": return _getVersion(ua, "Version/");
        case "WebKit": return _getVersion(ua, "WebKit/");
    }
    return "0.0.0";
}

function _isWebView(ua, os, browser, version, options) { // @ret Boolean - is WebView
    switch (os + browser) {
        case "iOSSafari": return false;
        case "iOSWebKit": return _isWebView_iOS(options);
        case "AndroidAOSP": return false; // can not accurately detect
        case "AndroidChrome": return parseFloat(version) >= 42 ? /; wv/.test(ua)
            : /\d{2}\.0\.0/.test(version) ? true // 40.0.0, 37.0.0, 36.0.0, 33.0.0, 30.0.0
                : _isWebView_Android(options);
    }
    return false;
}

function _isWebView_iOS(options) { // @arg Object - { WEB_VIEW }
    // @ret Boolean
    // Chrome 15++, Safari 5.1++, IE11, Edge, Firefox10++
    // Android 5.0 ChromeWebView 30: webkitFullscreenEnabled === false
    // Android 5.0 ChromeWebView 33: webkitFullscreenEnabled === false
    // Android 5.0 ChromeWebView 36: webkitFullscreenEnabled === false
    // Android 5.0 ChromeWebView 37: webkitFullscreenEnabled === false
    // Android 5.0 ChromeWebView 40: webkitFullscreenEnabled === false
    // Android 5.0 ChromeWebView 42: webkitFullscreenEnabled === ?
    // Android 5.0 ChromeWebView 44: webkitFullscreenEnabled === true
    var document = (global["document"] || {});

    if ("WEB_VIEW" in options) {
        return options["WEB_VIEW"];
    }
    return !("fullscreenEnabled" in document ||
        "webkitFullscreenEnabled" in document || false);
}

function _isWebView_Android(options) { // @arg Object - { WEB_VIEW }
    // Chrome 8++
    // Android 5.0 ChromeWebView 30: webkitRequestFileSystem === false
    // Android 5.0 ChromeWebView 33: webkitRequestFileSystem === false
    // Android 5.0 ChromeWebView 36: webkitRequestFileSystem === false
    // Android 5.0 ChromeWebView 37: webkitRequestFileSystem === false
    // Android 5.0 ChromeWebView 40: webkitRequestFileSystem === false
    // Android 5.0 ChromeWebView 42: webkitRequestFileSystem === false
    // Android 5.0 ChromeWebView 44: webkitRequestFileSystem === false
    if ("WEB_VIEW" in options) {
        return options["WEB_VIEW"];
    }
    return !("requestFileSystem" in global ||
        "webkitRequestFileSystem" in global || false);
}

function _getVersion(ua, token) { // @ret SemverString - "0.0.0"
    try {
        return _normalizeSemverString(ua.split(token)[1].trim().split(/[^\w\.]/)[0]);
    } catch (o_O) {
        // ignore
    }
    return "0.0.0";
}

function _normalizeSemverString(version) { // @arg String - "Major.Minor.Patch"
    // @ret SemverString - "Major.Minor.Patch"
    var ary = version.split(/[\._]/); // "1_2_3" -> ["1", "2", "3"]
    // "1.2.3" -> ["1", "2", "3"]
    return (parseInt(ary[0], 10) || 0) + "." +
        (parseInt(ary[1], 10) || 0) + "." +
        (parseInt(ary[2], 10) || 0);
}

function getIOSVersion() {
    //if (/iP(hone|od|ad)/.test(navigator.platform)) {
    //    // supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
    //    var v = (navigator.appVersion).match(/OS (\d+_\d+)/);
    //    return parseFloat(v[1].replace('_', '.'));
    //}
    return parseFloat(('' + (/CPU.*OS ([0-9_]{1,5})|(CPU like).*AppleWebKit.*Mobile/i.exec(navigator.userAgent) || [0, ''])[1]).replace('undefined', '3_2').replace('_', '.').replace('_', '')) || false;
}
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],21:[function(require,module,exports){
var isLocal = getLocal();
var isStaging = getStaging();
var isAdmin = getAdmin();
var domain = getDomain(isLocal, isStaging, isAdmin);
var clientDomain = getDomain(isLocal, isStaging, false);
var adminDomain = getDomain(isLocal, isStaging, false);
var appDomain = getAppDomain(isLocal, isStaging, isAdmin);
var reportDomain = getDomain(isLocal, isStaging, false);
var adminDomain = getDomain(isLocal, isStaging, true);

var stack = isLocal || isStaging ? 'staging' : 'production';

var config = {
    isAdmin: isAdmin,
    domain: domain,
    clientDomain: clientDomain,
    adminDomain: adminDomain,
    appDomain: appDomain,
    reportDomain: reportDomain,
    stack: stack,
    src: {
        firebase: 'https://www.gstatic.com/firebasejs/6.6.2/firebase.js',
        analytics: '//www.google-analytics.com/analytics.js',
    },
    widgets: {
        widgetUrl: appDomain + '/sdk/widgets/{widget}?id={id}',
    },
    firebase: {
        events: getBlunderboreEventsFirebaseConfig(isLocal, isStaging),
        chat: getChatFirebaseConfig(isLocal, isStaging),
        live: getBlunderboreLiveFirebaseConfig(isLocal, isStaging),
    },
    recaptcha: {
        siteKey: '6LdOAKIUAAAAAJCtnneL1ffRBCsHCo_FNuFGcCyi',
        url: 'https://www.google.com/recaptcha/api.js?render=explicit',
    },
    url: {
        configuration: adminDomain + '/configurations',
        //configuration: domain + '/configurations',
        player: domain + '/players/{id}/info',
        accessRules: domain + '/accessrules/{id}',
        refreshToken: domain + '/accessrules/token?key={token}',
        survey: domain + '/accessrules/portal/{id}',
        resource: domain + '/players/{webcastId}/resources/{resourceId}',
        share: {
            facebook: 'http://www.facebook.com/sharer.php?u={url}',
            twitter: 'https://twitter.com/share?url={url}',
            linkedin: 'http://www.linkedin.com/shareArticle?url={url}'
        },
        fireChatToken: domain + '/firebase',
        fireChat: 'https://scorching-fire-2945.firebaseio.com/chat/',
        askAQuestion: 'https://scorching-fire-2945.firebaseio.com/chat/room-messages/{roomId}.json?auth={token}',
        p2pUsage: domain + '/players/{id}/p2p/usage',
        chatHistory: domain + '/players/{id}/chat/history/',
        error: domain + '/report/error',
        viewers: reportDomain + '/players/{id}/report',
        vtt: {
            admin: {
                get: adminDomain + '/players/{id}/vtt/{path}/{language}',
                list: adminDomain + '/players/{id}/vtt/',
            },
            get: domain + '/players/{id}/vtt/{path}/{language}',
            list: domain + '/players/{id}/vtt/',
        },
        auth: {
            token: domain + '/auth/token',
            provider: domain + '/auth/api/{provider}?customerCode={customerCode}&successRedirect={successRedirect}&failureRedirect={failureRedirect}',
            successRedirect: appDomain + '/sdk/auth/identity/callback.html?success&identificationToken={token}',
            failureRedirect: appDomain + '/sdk/auth/identity/callback.html?failure',
        },
        slides: {
            upload: 'https://cwc-thumbs.s3.amazonaws.com/',
            get: 'https://vwsp5tdc06.execute-api.eu-west-1.amazonaws.com/' + stack + '/slides/{webcastId}',
            convert: 'https://vwsp5tdc06.execute-api.eu-west-1.amazonaws.com/' + stack + '/slides/{webcastId}/convert',
            remove: 'https://vwsp5tdc06.execute-api.eu-west-1.amazonaws.com/' + stack + '/slides/{webcastId}/delete',
            uploadCredentialsForm: 'https://vwsp5tdc06.execute-api.eu-west-1.amazonaws.com/' + stack + '/slides/{webcastId}/upload/credentials/form',
        },
        events: {
            admin: {
                list: adminDomain + '/players/{id}/eventsv2/list',
                //get: adminDomain + '/events/{id}',
                //post: adminDomain + '/events',
            },
            list: domain + '/players/{id}/eventsv2/list',
            //get: domain + '/events/{id}',
        },
        rivet: {
            audience: {
                conference: getRivetAudienceConferenceUrl(isLocal, isStaging, isAdmin)
            },
            proxy: '//rivet-proxy-{environment}.companywebcast.com',
        }
    },
    activeResourceViews: ['cwc.legacy.speaker', 'cwc.legacy.form', 'cwc.legacy.slide', 'cwc.legacy.topic'],
    resources: [
        {
            'name': 'speakers',
            'events': {
                'speakers.speaker:activate': true,
                'speakers.speaker:deactivate': false,
                'speakers.hide:deactivate': false,
                'dcnspeakers.speaker:activate': true,
                'dcnspeakers.hide:deactivate': false
            }
        },
        {
            'name': 'topics',
            'events': {
                'index.index:activate': true,
                'index.index:deactivate': false
            }
        },
        {
            'name': 'comments',
            'events': {
                'comments.comment:activate': true,
                'comments.hide:deactivate': false
            }
        },
        {
            'name': 'forms',
            'events': {
                'form.show:activate': true,
                'form.hide:deactivate': false
            }
        },
        {
            name: 'slides',
            events: {
                'slides.slide:activate': true,
                'slides.slide:deactivate': false,
            }
        }
    ],
    cast: {
        applicationId: isLocal || isStaging ? 'C0C9EDFF' : 'CD5FD6DC',
        urn: 'urn:x-cast:cwc.sdk.player',
    },
}

module.exports = config;

function getRivetAudienceConferenceUrl(isLocal, isStaging, isAdmin) {
    var appBaseUrl = (isLocal || isStaging)
        ? 'https://audienceconference.devrivet.net/{eventId}'
        : 'https://idontexistyet.net/{eventId}';

    return appBaseUrl + (isAdmin ? '/participant' : '/attendee');
}

function getDomain(isLocal, isStaging, isAdmin) {
    return '//sdk{admin}{staging}.companywebcast.com'
        .replace('{admin}', isAdmin ? '-admin' : '')
        .replace('{staging}', isLocal || isStaging ? '-staging' : '');
}

function getAppDomain(isLocal, isStaging, isAdmin) {
    if (isLocal) return '//localhost';
    return getDomain(isLocal, isStaging, isAdmin);
}

function getLocal() {
    return false;
}
function getStaging() {
    return false;
}
function getAdmin() {
    return false;
}

function getChatFirebaseConfig(isLocal, isStaging) {
    if (isLocal || isStaging) {
        return {
            token: domain + '/firebase',
            apiKey: "AIzaSyDTVlszjL3F67u0QjsZE6NP4OOpdCXEKbs",
            authDomain: "staging-chat-6c7df.firebaseapp.com",
            databaseURL: "https://staging-chat-6c7df.firebaseio.com",
            projectId: "staging-chat-6c7df",
            storageBucket: "staging-chat-6c7df.appspot.com",
            messagingSenderId: "866129312965",
            appId: "1:866129312965:web:da32e7554d11c1bd"
        }
    }

    return {
        token: domain + '/firebase',
        apiKey: "AIzaSyCkJHYk4uyrxBwtFm6dEoxSwsRO68uRxuU",
        authDomain: "scorching-fire-2945.firebaseapp.com",
        databaseURL: "https://scorching-fire-2945.firebaseio.com",
        projectId: "scorching-fire-2945",
        storageBucket: "scorching-fire-2945.appspot.com",
        messagingSenderId: "789939780219",
        appId: "1:789939780219:web:37a181686cb0fd4a"
    };
}

function getBlunderboreEventsFirebaseConfig(isLocal, isStaging) {
    if (isLocal || isStaging) {
        return {
            token: domain + "/accessrules/firebase/events",
            apiKey: "AIzaSyAoB5iGAGK3HEOH38C6HffCeYwaMEi2bhc",
            authDomain: "blunderbore-live-development.firebaseapp.com",
            databaseURL: "https://blunderbore-live-development.firebaseio.com",
            projectId: "blunderbore-live-development",
            storageBucket: "blunderbore-live-development.appspot.com",
            messagingSenderId: "551303059169"
        }
    }

    return {
        token: domain + "/accessrules/firebase/events",
        apiKey: "AIzaSyB1uBWs6TbIdT85w218DLGLWAjO1PwpKUA",
        authDomain: "blunderbore-live.firebaseapp.com",
        databaseURL: "https://blunderbore-live.firebaseio.com",
        projectId: "blunderbore-live",
        storageBucket: "blunderbore-live.appspot.com",
        messagingSenderId: "896486049217"
    }
}

function getBlunderboreLiveFirebaseConfig(isLocal, isStaging) {
    if (isLocal || isStaging) {
        return {
            apiKey: "AIzaSyAoB5iGAGK3HEOH38C6HffCeYwaMEi2bhc",
            authDomain: "blunderbore-live-development.firebaseapp.com",
            databaseURL: "https://blunderbore-live-development.firebaseio.com",
            projectId: "blunderbore-live-development",
            storageBucket: "blunderbore-live-development.appspot.com",
            messagingSenderId: "551303059169",
            appId: "1:551303059169:web:7f4d4b5944660e76"
        };
    }

    return {
        apiKey: "AIzaSyB1uBWs6TbIdT85w218DLGLWAjO1PwpKUA",
        authDomain: "blunderbore-live.firebaseapp.com",
        databaseURL: "https://blunderbore-live.firebaseio.com",
        projectId: "blunderbore-live",
        storageBucket: "blunderbore-live.appspot.com",
        messagingSenderId: "896486049217",
        appId: "1:896486049217:web:776e4952f6187cb2"
    };

}
},{}],22:[function(require,module,exports){
var http = require('./http.js');
var config = require('./config.js');

module.exports = {
    get: get,
};

var url = config.domain + '/portal/configuration/1.0/api/Configurations/{namespace}/';

function get(namespace) {
    return http.get(url.replace('{namespace}', namespace)).json().then(function (result) {
        var config = {};
        for (var i = 0, len = result.length; i < len; i++) {
            var key = result[i].key;
            var value = result[i].value;
            config[key] = value;
        }

        return config;
    });
}
},{"./config.js":21,"./http.js":26}],23:[function(require,module,exports){
var api = {
    get: get,
    set: set,
    clear: clear,
    remove: remove,
}

function get(name) {
    var cookies = document.cookie.split('; ');
    for (var i = 0, length = cookies.length; i < length; i++) {
        cookies[i] = cookies[i].split('=', 2);
        if (name == decodeURIComponent(cookies[i][0])) {
            return decodeURIComponent(cookies[i][1]);
        };
    }
    return null;
}

function clear() {
    (function () {
        var cookies = document.cookie.split("; ");
        for (var c = 0; c < cookies.length; c++) {
            var d = window.location.hostname.split(".");
            while (d.length > 0) {
                var cookieBase = encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) + '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' + d.join('.') + ' ;path=';
                var p = location.pathname.split('/');
                document.cookie = cookieBase + '/';
                while (p.length > 0) {
                    document.cookie = cookieBase + p.join('/');
                    p.pop();
                };
                d.shift();
            }
        }
    })();
}

function set(name, value, options) {
    var cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

    for (option in options) {
        switch (option) {
            case 'expires':
                cookie += '; expires=' + (isNaN(options[option]) ? options[option] : addDays(options[option]));
                break;
            case 'secure':
                cookie += '; secure'
                break;
            default:
                cookie += '; ' + option + '=' + options[option];
                break;
        }
    }

    document.cookie = cookie;
    return get(name) == value;
}

function remove(name) {
    return !set(name, '', { expires: -1 });
}

function addDays(days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 86400000);
    return date.toGMTString();
}

module.exports = api;

},{}],24:[function(require,module,exports){
var EventEmitter = require('./EventEmitter');

var eventEmitter = new EventEmitter();
var focusableId = 1;
var tabPressed = false;

var xmlns = "http://www.w3.org/2000/svg";
var skip = ['element', 'attributes', 'style', 'events', 'children', 'textContent', 'innerHTML'];
var visibilityClasses = ['hidden', 'visible', 'hidden-animate', 'visible-animate', 'removed'];
var pairedVisibilityClasses = {
    'hidden': {},
    'visible': {},
    'hidden-animate': {
        'hidden': true,
    },
    'visible-animate': {},
}


var promises = {
    scripts: {},
}

module.exports = {
    fromString: fromString,
    replace: replace,
    create: create,
    createSvg: createSvg,
    hide: hide,
    show: show,
    fadeIn: fadeIn,
    fadeOut: fadeOut,
    focusable: focusable,
    on: eventEmitter.on,
    loadScript: loadScript,
    loadScripts: loadScripts,
}

window.addEventListener('keydown', function (e) {
    if (e.keyCode == 9)
        tabPressed = true;
});

window.addEventListener('keyup', function (e) {
    if (e.keyCode == 9)
        tabPressed = false;
});

function fromString(string) {
    var element = document.createElement('div');
    element.innerHTML = string;
    return element.firstChild;
}

function replace(source, target) {
    try {
        source.parentNode.replaceChild(target, source);
        return target;
    } catch (e) {
        console.log(e);
    }

    return null;
}

function hide(element) {
    setVisibility(element, false, false);
}

function fadeOut(element) {
    setVisibility(element, false, true);
}

function show(element) {
    setVisibility(element, true, false);
}

function fadeIn(element) {
    setVisibility(element, true, true);
}

function setVisibility(element, visible, animate) {
    if (!element.touched) {
        element.touched = true;
        element.addEventListener('webkitAnimationEnd', addRemoveClass);
        element.addEventListener('animationend', addRemoveClass);
    }

    element.visible = visible;
    var className = visible ? 'visible' : 'hidden';
    if (animate) className += '-animate';

    setVisibilityClass(element, className);


    function addRemoveClass() {
        if (!element.visible) {
            element.classList.add('hidden');
            element.blur();
        }
    }
}

function setVisibilityClass(element, className) {
    for (var i = 0, length = visibilityClasses.length; i < length; i++) {
        if (visibilityClasses[i] != className && !pairedVisibilityClasses[className][visibilityClasses[i]]) {
            element.classList.remove(visibilityClasses[i]);
        }
    }
    if (!element.classList.contains(className)) {
        element.classList.add(className);
    }
}



function focusable(element, onFocus, onBlur) {
    element.tabIndex = 0;

    var eventData = {
        id: focusableId++,
    }

    element.addEventListener('focus', function (e) {
        if (tabPressed) {
            element.classList.add('focus-keyboard');
            if (onFocus) onFocus(e);
            eventEmitter.emit('focus', eventData);
        }
    });

    element.addEventListener('blur', function (e) {
        element.classList.remove('focus-keyboard');
        if (onBlur) onBlur(e);
        eventEmitter.emit('blur', eventData);
    });
}

function createSvg(options) {
    return create(options, xmlns);
}

function create(options, namespace) {
    var element;

    namespace ?
        element = document.createElementNS(xmlns, options.element) :
        element = document.createElement(options.element);

    for (var key in options.attributes) {
        var attr = options.attributes[key];
        if (attr !== undefined) {
            namespace ?
                element.setAttributeNS(null, key, options[key]) :
                element.setAttribute(key, attr);
        }
    }

    for (var key in options.events) {
        element.addEventListener(key, options.events[key]);
    }

    for (var key in options.style) {
        element.style[key] = options.style[key];
    }

    if (options.children && options.children.length > 0) {
        for (var i = 0, len = options.children.length; i < len; i++) {
            if (options.children[i]) {
                element.appendChild(options.children[i]);
            }
        }
    }

    for (var key in options) {
        if (skip.indexOf(key) == -1 && options[key] !== undefined) {
            namespace ?
                element.setAttributeNS(null, key, options[key]) :
                element.setAttribute(key, options[key]);
        }
    }

    if (options.textContent) element.textContent = options.textContent;
    if (options.innerHTML) element.innerHTML = options.innerHTML;

    return element;
}

function loadScripts(sources) {
    var promise;

    for(var i = 0; i < sources.length; i++) {
        promise = promiseLoadScript(promise, sources[i]);
    }

    return promise;
}

function promiseLoadScript(promise, src) {
    return promise ? promise.then(function() {
        return loadScript(src);
    }) : loadScript(src);
}

function loadScript(src) {
    var promise = promises.scripts[src];
    if (!promise) {
        promise = new Promise(function (resolve, reject) {
            var el = create({
                element: 'script',
                src: src,
            });

            el.onload = function () { resolve() };
            el.onerror = function (e) { reject(e) };

            document.head.appendChild(el);
        });

        promises.scripts[src] = promise;
    }

    return promise;
}
},{"./EventEmitter":9}],25:[function(require,module,exports){
module.exports = {
    v4: v4,
}

function v4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

},{}],26:[function(require,module,exports){
var XmlHttpPromise = require('./http/XmlHttpPromise.js');

module.exports = new Http();

function Http(options) {
    var _this = this;
    options = options || {};

    this.get = get;
    this.head = head;
    this.post = post;
    this.put = put;
    this.auth = auth;
    this.delete = del;
    this.sign = XmlHttpPromise.sign;

    function get(url, params) {
        params = params || {};
        params.method = 'GET';
        params.url = url;
        params.auth = options.auth;
        return new XmlHttpPromise(params);
    }

    function head(url, params) {
        params = params || {};
        params.method = 'HEAD';
        params.url = url;
        params.auth = options.auth;
        return new XmlHttpPromise(params);
    }

    function post(url, data, params) {
        params = params || {};
        params.method = 'POST';
        params.url = url;
        params.data = data;
        params.auth = options.auth;
        return new XmlHttpPromise(params);
    }
    function put(url, data, params) {
        params = params || {};
        params.method = 'PUT';
        params.url = url;
        params.data = data;
        params.auth = options.auth;
        return new XmlHttpPromise(params);
    }

    function del (url, params) {
        params = params || {};
        params.method = 'DELETE';
        params.url = url;
        params.auth = options.auth;
        return new XmlHttpPromise(params);
    }

    function auth(auth) {
        return new Http({ auth: auth });
    }

}
},{"./http/XmlHttpPromise.js":27}],27:[function(require,module,exports){
module.exports = XmlHttpPromise;

function XmlHttpPromise(params) {
    this.params = params;
}

XmlHttpPromise.sign = sign;

XmlHttpPromise.prototype.json = function () {
    if (this.params.data) this.params.data = JSON.stringify(this.params.data);
    this.params.headers = this.params.headers || {};
    this.params.headers['Content-Type'] = 'application/json';

    return requestPromise(this.params).then(function (result) {
        if (result.responseText) {
            return JSON.parse(result.responseText);
        }
    });
}

XmlHttpPromise.prototype.text = function () {
    return requestPromise(this.params).then(function (result) {
        return result.responseText;
    });
}

XmlHttpPromise.prototype.form = function () {
    this.params.headers = this.params.headers || {};

    var str = [];
    for (var p in this.params.data) {
        str.push(encodeURIComponent(p) + "=" + (this.params.data[p] ? encodeURIComponent(this.params.data[p]) : ''));
    }
    this.params.data = str.join("&").replace(/%20/g, '+');
    this.params.headers['Content-Type'] = 'application/x-www-form-urlencoded';

    return requestPromise(this.params).then(function (result) {
        if (result.responseText) {
            return JSON.parse(result.responseText);
        }
    });
}

XmlHttpPromise.prototype.raw = function () {
    return requestPromise(this.params);
}

XmlHttpPromise.getTokenForUrl = getTokenForUrl;

function requestPromise(params) {
    applyAuth(params);
    return applyTransformRequest(params).then(function (params) {
        return new Promise(function (resolve, reject) {

            try {
                var xmlHttp = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");

                applyQuery(xmlHttp, params);
                xmlHttp.open(params.method, params.url, true);
                if (params.withCredentials) xmlHttp.withCredentials = true;
                applyHeaders(xmlHttp, params);

                xmlHttp.onreadystatechange = function () {
                    if (xmlHttp.readyState == 4) {
                        switch (xmlHttp.status) {
                            case 200:
                            case 204:
                                resolve(xmlHttp);
                                break;
                            default:
                                var response;

                                try {
                                    response = JSON.parse(xmlHttp.responseText);
                                } catch (e) {
                                    response = xmlHttp.response;
                                }

                                reject({
                                    status: xmlHttp.status,
                                    response: response,
                                });
                                break;
                        }
                    }
                }

                xmlHttp.send(params.data);
            } catch (e) {
                reject(e);
            }
        });
    });
}

function getQueryParameters(str) {
    if (str.indexOf('?') == -1) return {};
    return str.replace(/^.*?\?/, '').split("&").map(function (n) { return n = n.split("="), this[n[0]] = decodeURIComponent(n[1]), this }.bind({}))[0];
}

function getUrlWithoutQuery(str) {
    return str.replace(/\?.*/, '');
}

function applyHeaders(xmlHttp, params) {
    if (params.headers) {
        for (var header in params.headers) {
            xmlHttp.setRequestHeader(header, params.headers[header]);
        }
    }
}

function applyQuery(xmlHttp, params) {
    if (!params.query) return;

    var query = getQueryParameters(params.url);
    var url = getUrlWithoutQuery(params.url);

    for (var key in params.query) {
        query[key] = params.query[key];
    }

    var first = true;
    for (var key in query) {

        url = url + (first ? '?' : '&') + key + '=' + query[key]

        first = false;
    }

    params.url = url;
}

function applyTransformRequest(params) {
    if (params.transformRequest) {
        return Promise.resolve(params.transformRequest(params)).then(function () {
            return params;
        });
    }

    return Promise.resolve(params);
}

function applyAuth(params) {
    if (params.auth) {
        var oldTransformRequest = params.transformRequest;

        params.transformRequest = function (params) {
            return params.auth.accessRules.getTokens().then(function (tokens) {
                var token = getTokenForUrl(params.url, params.auth.webcastId, tokens);

                params.headers = params.headers || {};
                params.query = params.query || {};

                if (token) {
                    params.query.Signature = token.Signature;
                    params.query.Policy = token.Policy;
                    params.query['Key-Pair-Id'] = token['Key-Pair-Id'];
                }

                params.headers['X-Authorization'] = tokens.legacyPulseToken;

                if (oldTransformRequest) return oldTransformRequest(params);
            });
        }
    }

    return params;
}

function sign(url, webcastId, tokens) {
    var token = getTokenForUrl(url, webcastId, tokens);
    var first = true;
    if (url.indexOf('?') > -1) {
        first = false;
    }

    for (var key in token) {
        url += first ? '?' : '&';
        url += key + '=' + token[key];
        first = false;
    }
    return url;
}

function getTokenForUrl(url, webcastId, tokens) {
    var t = tokens.cloudFrontTokens[isSecure(url) ? 'ssl' : 'non-ssl'];

    if (url.indexOf('/players') > -1) {
        return t.players;
    } else if (url.indexOf('/playlist') > -1) {
        return t.playlist;
    } else {
        return t[webcastId];
    }
}

function isSecure(url) {
    if (url.indexOf('https://') > -1) return true;
    if (window.location.href.indexOf('https://') > -1) return true;
    return false;
}
},{}],28:[function(require,module,exports){
var cookies = require('./cookies.js');

module.exports = new LocalStorage();

function LocalStorage() {

    var implementation

    try {
        window.localStorage.test = 'test';
        delete window.localStorage.test;
        implementation = new LocalStorageImplementation();
    } catch (e) {
        try {
            cookies.set('test', 'test');
            cookies.remove('test');
            console.warn('localstorage falling back to cookie implementation');
            implementation = new CookieImplementation();
        } catch (e) {
            console.warn('localstorage falling back to dummy implementation');
            implementation = new DummyImplementation();
        }
    }

    this.get = get;
    this.set = set;
    this.setRememberMe = setRememberMe;
    this.clear = clear;

    function setRememberMe(value) {
        implementation.set('rememberme', !!value);
        if (!value) {
            implementation.clear();
        }
    }

    function get(key) {
        var string = implementation.get(key);

        if (string) {
            try {
                return JSON.parse(string);
            } catch (e) {
                console.warn('could not parse string', key, string);
            }
        }

        return null;
    }

    function set(key, value) {
        return implementation.set(key, JSON.stringify(value));
    }

    function clear() {
        return implementation.clear();
    }

    function LocalStorageImplementation() {

        this.get = get;
        this.set = set;
        this.clear = clear;

        function get(key) {
            try {
                return decodeURIComponent(window.localStorage.getItem(key));
            } catch (e) {
                try {
                    return window.localStorage.getItem(key);
                } catch (e) {
                    console.log(e);
                }
            }
        }

        function set(key, value) {
            try {
                return window.localStorage.setItem(key, value);
            } catch (e) {
                console.log(e);
            }
        }

        function clear() {
            try {
                localStorage.clear();
            } catch (e) {
                console.log(e);
            }
        }
    }

    function CookieImplementation() {

        this.get = get;
        this.set = set;
        this.clear = clear;

        function get(key) {
            try {
                return decodeURIComponent(cookies.get(key));
            } catch (e) {
                console.log(e);
            }
        }

        function set(key, value) {
            try {
                return cookies.set(key, encodeURIComponent(value), {
                    expires: 7,
                });
            } catch (e) {
                console.log(e);
            }
        }

        function clear() {
            try {
                cookies.clear();
            } catch (e) {
                console.log(e);
            }
        }
    }

    function DummyImplementation() {
        function doNothing() { }

        this.get = doNothing;
        this.set = doNothing;
        this.clear = doNothing;
    }
}
},{"./cookies.js":23}],29:[function(require,module,exports){
var EventEmitter = require('./EventEmitter.js');
var browserSniffing = require('./browserSniffing.js');
var localStorage = require('./localStorage.js');
var serverTime = require('./serverTime.js');
var guid = require('./guid.js');
var http = require('./http.js');
var config = require('./config.js');

var dom = require('./dom.js');

var level = {
    error: 'error',
    warn: 'warn',
    info: 'info',
}

var eventEmitter = new EventEmitter(true);
var logElement = dom.create({
    element: 'div',
    class: 'log',
    attributes: {
        style: 'z-index:100000;position:absolute;top:0;left:0;background-color:black;color:white',
    }
});

var api = {
    writeToConsole: false,
    level: level,
    on: on,
    error: error,
    warn: warn,
    info: info,
    hijackConsole: hijackConsole,
    sendMetric: sendMetric,
    fingerprint: getFingerprint(),
}

function on(event, callback) {
    return eventEmitter.on(event, callback);
}

function error(message, data) {
    log(level.error, message, data);
    sendMetric(level.error, message, data);
}

function getFingerprint() {
    var fingerprint = localStorage.get('fingerprint');
    if (!fingerprint) {
        fingerprint = guid.v4();
        localStorage.set('fingerprint', fingerprint);
    }
    return fingerprint;
}

function sendMetric(level, message, data) {
    var date = new Date(serverTime()).toISOString();
    var error = {
        level: level,
        message: message,
        data: data,
        fingerprint: api.fingerprint,
        timestamp: date,
        os: browserSniffing.os,
        browser: browserSniffing.browser + ' ' + browserSniffing.browserVersion,
        webview: browserSniffing.webView,
    }

    for (var key in api.scope) {
        error[key] = api.scope[key];
    }
    http.post(config.url.error, error).json();
}

function warn(message, data) {
    log(level.warn, message, data);
    sendMetric(level.warn, message, data);
}

function info(message, data) {
    log(level.info, message, data);
}

function log(level, message, data) {
    var log = {
        level: level,
        message: message,
        data: data,
    }

    eventEmitter.emit('log', log);
    eventEmitter.emit(level, log);

    if (api.writeToConsole && console && console[level]) {
        if (data) {
            console[level](message, data);
        } else {
            console[level](message);
        }
    }
}

function hijackConsole() {
    document.body.appendChild(logElement);
    overwriteConsole('log');
    overwriteConsole('warn');
    overwriteConsole('error');
    overwriteConsole('info');
    overwriteConsole('debug');
    overwriteConsole('trace');

    window.onerror = function () {
        logElement.appendChild(dom.create({
            element: 'pre',
            textContent: JSON.stringify(arguments),
        }));
    }
}

function overwriteConsole(func) {
    var oldFunc = console[func];

    console[func] = function () {
        logElement.appendChild(dom.create({
            element: 'pre',
            textContent: JSON.stringify(arguments, null, ' '),
        }));

        oldFunc.apply(console, arguments);
    }

}


module.exports = api;
},{"./EventEmitter.js":9,"./browserSniffing.js":20,"./config.js":21,"./dom.js":24,"./guid.js":25,"./http.js":26,"./localStorage.js":28,"./serverTime.js":32}],30:[function(require,module,exports){
module.exports = {
    legacy: 'legacy',
    rivetLiveStream: 'RivetLiveStream',
    rivetConference: 'RivetConference',
}
},{}],31:[function(require,module,exports){
var GoogleAnalyticsApi = require('../GoogleAnalytics.js');
var http = require('../http.js');
var config = require('../config.js');

module.exports = GoogleAnalytics;

function GoogleAnalytics(player) {

    var virtualPageTemplate = 'cwc.sdk.player/{customerCode}/{id}/{action}?phase={phase}';
    var phase = 'unknown';
    var error = false;

    phase = player.isFragment ? 'fragment' : player.info.phase;
    virtualPageTemplate = virtualPageTemplate.replace('{id}', player.info.id).replace('{customerCode}', player.info.customer.code);

    var gaApi = new GoogleAnalyticsApi(player.info.customer.config['setting.google.analytics.key']);

    this.sendVirtualPageView = sendVirtualPageView;

    player.on('phase.state:change', function (e) {
        phase = player.isFragment ? 'fragment' : e.state;
    });

    function sendVirtualPageView(action) {
        if (gaApi) {
            var virtualPage = virtualPageTemplate.replace('{action}', action).replace('{phase}', phase);
            gaApi.sendVirtualPageView({
                page: virtualPage,
                title: action,
            });
        }
    }
}
},{"../GoogleAnalytics.js":10,"../config.js":21,"../http.js":26}],32:[function(require,module,exports){
var http = require('./http');
var config = require('./config');
module.exports = get;

//var epoch = 0;
var diff = 0;
//var lastTimestamp = performance.now();
//var currentTimestamp = performance.now();

getTimeFromServer();

function getTimeFromServer() {
    var url = config.domain + '/time/now';

    http.get(url).json().then(function (result) {
        //lastTimestamp = performance.now();
        //currentTimestamp = performance.now();
        diff = result.epoch - new Date().getTime();
        console.log('serverTime offset', diff);
    });
}

function get() {
    return new Date().getTime() + diff;
}




},{"./config":21,"./http":26}]},{},[4]);
